webpackJsonp([1],{

/***/ "+mQk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_swiper_vue__ = __webpack_require__("4svQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6706024c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_swiper_vue__ = __webpack_require__("gImT");
function injectStyle (ssrContext) {
  __webpack_require__("x8Pr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6706024c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_swiper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6706024c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_swiper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+p9J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },
  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),

/***/ "+vZe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/7LY":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNy4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHdpZHRoPSIyMC44OTFweCIgaGVpZ2h0PSIxMi43MjdweCIgdmlld0JveD0iMCAwIDIwLjg5MSAxMi43MjciIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDIwLjg5MSAxMi43MjciIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGcgaWQ9IkxheWVyXzIiPg0KPC9nPg0KPGcgaWQ9IkxheWVyXzEiPg0KCTxwYXRoIGQ9Ik0xMS4xODcsMTIuNDIzbDEuOTg0LTEuOTc1bDcuNDExLTcuMzc1YzAuNDA4LTAuNDA2LDAuNDEyLTEuMDc0LDAuMDA4LTEuNDg0TDE5LjMzNywwLjMxDQoJCWMtMC40MDMtMC40MTEtMS4wNjYtMC40MTQtMS40NzMtMC4wMDdsLTYuNjgsNi42OGwtMC43MzgsMC43NGwtMC43NC0wLjc0bDAsMGwtNi42OC02LjY4QzIuNjE5LTAuMTA0LDEuOTU3LTAuMTAxLDEuNTU0LDAuMzENCgkJTDAuMjk5LDEuNTg4Yy0wLjQwMywwLjQxMS0wLjM5OSwxLjA3OCwwLjAwOCwxLjQ4NGw3LjQxMSw3LjM3NWwxLjk4NCwxLjk3NUMxMC4xMTIsMTIuODI5LDEwLjc3OSwxMi44MjksMTEuMTg3LDEyLjQyM3oiLz4NCjwvZz4NCjxnIGlkPSJMYXllcl8zIiBkaXNwbGF5PSJub25lIj4NCjwvZz4NCjwvc3ZnPg0K"

/***/ }),

/***/ "0EzP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px3"},[_c('div',{staticClass:"bb-h60vh"},[_c('div',{staticClass:"center clearfix relative bb-vcr"},[_c('div',{staticClass:"bb-ff2 bb-fs2pt17 bb-fc1"},[_vm._v("THANK YOU")]),_vm._v(" "),_c('div',{staticClass:"mt2 bb-ff2 bb-fs1pt13 bb-fc3 bb-lh1pt5 bb-mx2 bb-sm-mx10 bb-md-mx1"},[_vm._v("\n      "+_vm._s(_vm.$lang.messages.pay_suc)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"bb-mt2pt56 mx-auto bb-w12"},[_c('router-link',{staticClass:"text-decoration-none border-none",attrs:{"to":"/"}},[_c('div',{staticClass:"center mx-auto border-box bb-pointer bb-bc2-hover bb-bc2 bb-sm-bc-transp\n          bb-ff3 bb-fs1 bb-fc1 bb-sm-fc2 bb-fc1-hover bb-brd3 bb-h2pt5 bb-py1pt25 bb-lh0\n          bb-transition2"},[_vm._v("\n          "+_vm._s(_vm.$lang.messages.user_continue)+"\n          ")])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0rhx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0sfo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'miniNotification',
  props: ['msg', 'success']
});

/***/ }),

/***/ "1N7e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ReturnPolicy',
  data: function data() {
    return {
      scrollView: null
    };
  },

  methods: {
    scrollViewScrolled: function scrollViewScrolled(event) {
      this.toggleGradient(event.target);
    },
    scrolledToEnd: function scrolledToEnd(el) {
      return el.scrollHeight - el.scrollTop <= el.clientHeight;
    },
    resized: function resized() {
      this.calcScrollViewMaxHeight(this.scrollView);
      this.toggleGradient(this.scrollView);
    },
    calcScrollViewMaxHeight: function calcScrollViewMaxHeight(el) {
      var windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
      var scrollViewY = el.getBoundingClientRect().top;
      var footerHeight = document.getElementById('footer').offsetHeight;
      var pageMarginBottom = 8 * parseFloat(getComputedStyle(document.documentElement).fontSize);
      el.style.maxHeight = windowHeight - scrollViewY - footerHeight - pageMarginBottom + 'px';
    },
    toggleGradient: function toggleGradient(el) {
      if (this.scrolledToEnd(el)) {
        document.getElementById('scrollGradient').classList.add('bb-op0');
      } else {
        document.getElementById('scrollGradient').classList.remove('bb-op0');
      }
    }
  },
  mounted: function mounted() {
    this.scrollView = document.getElementById('scrollView');
    this.scrollView.addEventListener('scroll', this.scrollViewScrolled);

    window.addEventListener('resize', this.resized);

    this.calcScrollViewMaxHeight(this.scrollView);
    this.toggleGradient(this.scrollView);
  },
  destroyed: function destroyed() {
    this.scrollView.removeEventListener('scroll', this.scrollViewScrollEnd);
    window.removeEventListener('resize', this.resized);
  }
});

/***/ }),

/***/ "1hbY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',{staticClass:"relative mx3 bb-mt2pt56"},[_c('div',{staticClass:"bb-pl20p bb-xl-pl0 bb-pr20p bb-xl-pr40p bb-min-h20\n      bb-ff2 bb-fs1pt2 bb-fc1 bb-ofy-auto bb-hyphens-auto border-box center bb-xl-justify",attrs:{"id":"scrollView"}},[_c('div',{staticClass:"bb-ff2 bb-fs1pt2 bb-fc2"},[_vm._v("\n        PRIVACY POLICY FOR BIG BANG SERVICES\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1pt29 bb-fc3 mt1"},[_vm._v("\n        Your privacy is important to us. \n      ")]),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1pt29 bb-fc3 mt1"},[_vm._v("\n        This Privacy Statement describes the types of information Bigbang\n        collects from and about you when you visit our website. \n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"bb-ff3 bb-fs1pt2 bb-fc1"},[_vm._v("\n        COLLECTION AND USAGE\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1pt29 bb-fc1"},[_vm._v("\n        We’d like to get to know you\n      ")]),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1pt29 bb-fc3 mt1"},[_vm._v("\n        We collect information about your computer or device, e.g. your IP\n        address. We might ask for your name, number, and email so we can\n        ensure you have a great experience.\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1pt2 bb-fc1"},[_vm._v("\n        STORAGE\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1pt29 bb-fc1"},[_vm._v("\n        Your information is safe with us\n      ")]),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1pt29 bb-fc3 mt1"},[_vm._v("\n        We are very protective of the information that you provide us with and\n        we have taken certain physical, administrative, and technical steps to\n        safeguard the information we collect from and about our customers and\n        Site visitors. We keep the data for as long as it is needed or\n        required by law.\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1pt2 bb-fc1"},[_vm._v("\n        TRANSFER\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1pt29 bb-fc1"},[_vm._v("\n        Sharing information with others\n      ")]),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1pt29 bb-fc3 mt1"},[_vm._v("\n        We do not share your information with others unless you allow us to.\n        We do share it with our affiliated companies and our third party\n        service providers that provide business, professional or technical\n        support functions for us, including to the extent necessary or\n        desirable to complete your transaction.\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1pt2 bb-fc1"},[_vm._v("\n        CONTACT\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1pt29 bb-fc1"},[_vm._v("\n        The information about you\n      ")]),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1pt29 bb-fc3 mt1"},[_vm._v("\n        If you should have any questions about this Privacy Statement or the\n        practices described herein, or, if you want to know what information\n        we have on you, or if you wish to delete said information, please\n        don’t hesitate to get in contact with us at Hello@bbangstudios.com\n      ")])]),_vm._v(" "),_c('div',{staticClass:"absolute bottom-0 left-0 right-0 bb-h25 bb-gradient1\n      bb-events-none bb-transition2",attrs:{"id":"scrollGradient"}})]),_vm._v(" "),_c('div',{staticClass:"absolute left-0 right-0 top-0 bottom-0 bb-zindexn1 bb-bc-black"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "41Su":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'slider',
  props: ['sliderData'],
  data: function data() {
    return {
      sliderWidth: 0,
      activeSlideIndex: -1,
      flatMode: false, // flat mode is when theres no need for sliding functionality
      canSlide: true,
      canRegulate: false,
      slideWidthClass: 'bb-w28', // determines individual slide width
      slideHeightClass: 'bb-h16', // determines individual slide height
      slidePaddingClass: 'px2', // determines individual slide padding in flatmode
      transitionClass: '', // determines slide transition
      tempTransitionClass: 'bb-transition1',
      direction: 'none',
      imageName: '/502-featured.jpg'
    };
  },

  methods: {
    calculateSliderWidth: function calculateSliderWidth() {
      if (this.sliderData.length === 1) {
        // increase size of poster if comingSoon has one slide
        this.slideWidthClass = 'bb-w29';
        this.slideHeightClass = 'bb-h18pt77';
      }

      var slideWidth = this.$utilities.getWidthOfClass('.' + this.slideWidthClass);
      var slidePadding = this.$utilities.getClassStyle('.' + this.slidePaddingClass).paddingLeft;
      // takes into account spacing between slides only in flatmode
      slidePadding = this.$utilities.parseStyleString(slidePadding);
      if ((slideWidth.value + slidePadding.value * 2) * parseFloat(getComputedStyle(document.documentElement).fontSize) * this.sliderData.length < document.body.clientWidth) {
        // flatmode if slides fit in screen
        this.flatMode = true;

        this.sliderWidth = (slideWidth.value + slidePadding.value * 2) * this.sliderData.length + slideWidth.unit;

        this.activeSlideIndex = Math.floor(this.sliderData.length / 2);
      } else {
        // slider mode if slides dont fit in screen
        this.flatMode = this.sliderData.length === 1; // if slides > 1 then enter slider mode

        this.sliderWidth = slideWidth.value * (this.sliderData.length * 3 + (this.sliderData.length % 2 === 0 ? 1 : 0)) + slideWidth.unit;

        this.activeSlideIndex = Math.floor(this.sliderData.length / 2) + this.sliderData.length;
      }
      this.sliderRenderFinished();
    },
    resized: function resized() {
      // recalculates slider width on screen resize to change mode if needed
      this.calculateSliderWidth();
    },
    slideHovered: function slideHovered(e) {
      var slide = this.mapToParentSlide(e.target);
      var index = parseInt(slide.getAttribute('index'));

      this.slideToNextSlide(index);
    },
    sliderSwiped: function sliderSwiped(el, direction) {
      if (direction === 'left') {
        this.slideToNextSlide(this.activeSlideIndex + 1);
      } else if (direction === 'right') {
        this.slideToNextSlide(this.activeSlideIndex - 1);
      }
    },
    slideToNextSlide: function slideToNextSlide(newIndex) {
      if (this.canSlide) {
        if (this.transitionClass === '') {
          // re-add animation if removed during regulation
          this.transitionClass = this.tempTransitionClass;
        }

        // determine direction of slide to help regulate
        if (this.activeSlideIndex > newIndex) {
          this.direction = 'left';
        } else if (this.activeSlideIndex < newIndex) {
          this.direction = 'right';
        } else {
          this.direction = 'none';
        }

        this.activeSlideIndex = newIndex;

        this.canRegulate = true;
      }
    },
    mapToParentSlide: function mapToParentSlide(target) {
      // find closest parent slide
      if (this.isSlide(target)) {
        return target;
      } else {
        return this.mapToParentSlide(target.parentNode);
      }
    },
    isSlide: function isSlide(target) {
      return this.$utilities.hasClass(target, 'slide');
    },
    getSlideByIndex: function getSlideByIndex(i) {
      var slides = document.getElementsByClassName('slide');
      for (var index in slides) {
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(slides[index]) === 'object' && slides[index].getAttribute('index') === String(i)) {
          return slides[index];
        }
      }
    },
    calcIndex: function calcIndex(i, n) {
      //calculates and returns the proper index for every slide
      return i + (n - 1) * this.sliderData.length + (this.sliderData.length % 2 === 0 && !this.flatMode ? 1 : 0);
    },
    calcRotationDeg: function calcRotationDeg(index) {
      // new rotation degree for each slide on hover
      // for 3d effect
      var degree = 35;
      return this.flatMode ? 0 : degree * (this.activeSlideIndex - index);
    },
    calcPerspectiveOrigin: function calcPerspectiveOrigin(n) {
      // new perspective origin for each slide on hover
      // for 3d effect
      var perspective = 50 / this.sliderData.length;
      return perspective + (this.activeSlideIndex - 1 - this.sliderData.length + (this.sliderData.length % 2 === 0 ? 0 : 1)) * (100 / this.sliderData.length) - (n - 2) * 100;
    },
    calcSliderPosition: function calcSliderPosition(any) {
      // new position for each slide on hover
      var slideWidth = this.$utilities.getWidthOfClass('.' + this.slideWidthClass);
      var position = -(slideWidth.value * (Math.floor(this.sliderData.length / 2) - (this.activeSlideIndex - this.sliderData.length)));
      position = this.flatMode ? 0 : position; // resets position to center if flatmode
      return position + slideWidth.unit;
    },
    regulate: function regulate() {
      // if index goes out of bounds from center indexes, then re-center
      if ((this.activeSlideIndex < this.sliderData.length + (this.sliderData.length % 2 === 0 ? 1 : 0) || this.activeSlideIndex >= this.sliderData.length * 2 + (this.sliderData.length % 2 === 0 ? 1 : 0)) && this.canRegulate) {
        this.canRegulate = false;
        this.canSlide = false;
        var self = this;
        setTimeout(function () {
          self.canSlide = true;
          // removes animation for seemless re-centering
          self.transitionClass = '';
          var offset = self.direction === 'left' ? self.sliderData.length : self.direction === 'right' ? -self.sliderData.length : 0;
          self.activeSlideIndex = self.activeSlideIndex + offset;
        }, this.$utilities.getTransitionDurationOfClass('.' + this.transitionClass) * 1000);
      }
    },
    slidePosterClicked: function slidePosterClicked() {
      this.$emit('emitSlidePosterClicked');
    },
    getImageUrl: function getImageUrl(uri, name) {
      return this.$store.getters.getImageUrl(uri, name);
    },
    getBgImageUrlString: function getBgImageUrlString(uri, name) {
      return 'url("' + this.getImageUrl(uri, name) + '")';
    },
    sliderRenderFinished: function sliderRenderFinished() {
      this.$emit('sliderRenderFinished');
    }
  },
  watch: {
    'activeSlideIndex': 'regulate',
    'sliderData': 'resized'
  },
  mounted: function mounted() {
    this.calculateSliderWidth();

    var sliderInners = document.getElementsByClassName('slider-inner');
    for (var i in sliderInners) {
      // there are currently 2 sliders, add swipe feature to both
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(sliderInners[i]) === 'object' && sliderInners[i].getAttribute('swipe-added') === 'false') {
        this.$utilities.detectSwipe(sliderInners[i], this.sliderSwiped);
        sliderInners[i].setAttribute('swipe-added', 'true');
      }
    }
  },
  created: function created() {
    window.addEventListener('resize', this.resized);
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.resized);
  }
});

/***/ }),

/***/ "4Laz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4svQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'carrousel',
  props: ['swiperData'],
  data: function data() {
    var self = this;
    return {
      sliderStart: true,
      sliderEnd: false,
      imageName: '/501-poster.jpg',
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 0,
        simulateTouch: false,
        onReachBeginning: function onReachBeginning(swiper) {
          self.sliderStart = true;
        },
        onReachEnd: function onReachEnd(swiper) {
          self.sliderEnd = true;
        },
        breakpoints: {
          736: {
            slidesPerView: 1,
            spaceBetween: 0
          }
        }
      }
    };
  },

  computed: {
    swiper: function swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  watch: {
    'swiperData': function swiperData() {
      this.sliderStart = true, this.sliderEnd = false;
    }
  },
  methods: {
    getImageUrl: function getImageUrl(uri, name) {
      return this.$store.getters.getImageUrl(uri, name);
    },
    slidePrev: function slidePrev() {
      this.swiper.slidePrev(true, 500);
      if (!this.sliderStart) {
        this.sliderEnd = false;
      }
    },
    slideNext: function slideNext() {
      this.swiper.slideNext(true, 500);
      if (!this.sliderEnd) {
        this.sliderStart = false;
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "5Bov":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "7d4M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_slider_vue__ = __webpack_require__("41Su");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_317ae9f1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slider_vue__ = __webpack_require__("yVls");
function injectStyle (ssrContext) {
  __webpack_require__("zBR+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-317ae9f1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_slider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_317ae9f1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7oBO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

var browser = typeof window !== 'undefined';
if (browser) window.Swiper = __webpack_require__("gsqX");
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    },
    notNextTick: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function () {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),

/***/ "85DX":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE3LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgd2lkdGg9IjEwLjQ4OXB4IiBoZWlnaHQ9IjIyLjQ3NHB4IiB2aWV3Qm94PSIwIDAgMTAuNDg5IDIyLjQ3NCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMTAuNDg5IDIyLjQ3NCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgZmlsbD0iI2NjY2NjYyI+CjxnIGlkPSJMYXllcl8yIj4KPC9nPgo8ZyBpZD0iTGF5ZXJfMSI+CjwvZz4KPGcgaWQ9Ikd1aWRlIj4KCTxnPgoJCTxnPgoJCQk8cGF0aCBkPSJNMi4yNjcsNC4zNTN2My4wOTNIMHYzLjc4NGgyLjI2N3YxMS4yNDVoNC42NTdWMTEuMjMxaDMuMTI1YzAsMCwwLjI5My0xLjgxNCwwLjQzNi0zLjc5OEg2Ljk0MlY0Ljg0NQoJCQkJYzAtMC4zODYsMC41MDctMC45MDYsMS4wMS0wLjkwNmgyLjUzN1YwSDcuMDM4QzIuMTUyLDAsMi4yNjcsMy43ODcsMi4yNjcsNC4zNTNMMi4yNjcsNC4zNTN6Ii8+CgkJPC9nPgoJPC9nPgo8L2c+CjxnIGlkPSJMYXllcl80IiBkaXNwbGF5PSJub25lIj4KPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "8cbe":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSIzOCIgaGVpZ2h0PSIzOCIKICB2aWV3Qm94PSIwIDAgMzggMzgiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaW5ZTWluIG1lZXQiPgogIDxwYXRoIGZpbGw9IiMxZGFkNGQiIHN0cm9rZT0iIzFkYWQ0ZCIgc3Ryb2tlLXdpZHRoPSIwLjYwMjciIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTUuMjAzLDIwIGMwLTguMTU5LDYuNjM4LTE0Ljc5NywKICAgIDE0Ljc5Ny0xNC43OTdWNUMxMS43MjksNSw1LDExLjcyOSw1LDIwczYuNzI5LDE1LDE1LDE1di0wLjIwM0MxMS44NDEsMzQuNzk3LDUuMjAzLDI4LjE1OSw1LjIwMywyMHoiPgogICAgPGFuaW1hdGVUcmFuc2Zvcm0gYXR0cmlidXRlTmFtZT0idHJhbnNmb3JtIiB0eXBlPSJyb3RhdGUiIGZyb209IjAgMjAgMjAiIHRvPSIzNjAgMjAgMjAiIGNhbGNNb2RlPSJzcGxpbmUiCiAgICAgIGtleVNwbGluZXM9IjAuNCwgMCwgMC4yLCAxIiBrZXlUaW1lcz0iMDsxIiBkdXI9IjFzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIvPiAgICAgIAogIDwvcGF0aD4KCiAgPHBhdGggZmlsbD0iIzFkYWQ0ZCIgc3Ryb2tlPSIjMWRhZDRkIiBzdHJva2Utd2lkdGg9IjAuMjAyNyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBkPSJNNy4wNzgsMjAKICAgIGMwLTcuMTI1LDUuNzk3LTEyLjkyMiwxMi45MjItMTIuOTIyVjYuODc1QzEyLjc2Myw2Ljg3NSw2Ljg3NSwxMi43NjMsNi44NzUsMjBTMTIuNzYzLDMzLjEyNSwyMCwzMy4xMjV2LTAuMjAzCiAgICBDMTIuODc1LDMyLjkyMiw3LjA3OCwyNy4xMjUsNy4wNzgsMjB6Ij4KICAgIDxhbmltYXRlVHJhbnNmb3JtIGF0dHJpYnV0ZU5hbWU9InRyYW5zZm9ybSIgdHlwZT0icm90YXRlIiBmcm9tPSIwIDIwIDIwIiB0bz0iMzYwIDIwIDIwIiBkdXI9IjAuOHMiCiAgICAgIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIi8+CiAgPC9wYXRoPgo8L3N2Zz4K"

/***/ }),

/***/ "8y3W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute top-0 left-0 bb-zindex1 bb-bc10 bb-h100vh bb-w100vw bb-fullscreen bb-usnone",on:{"click":_vm.highlightCancelBtn}},[_c('div',{staticClass:"mx-auto relative bb-vcr bb-br5 border-box p3 bb-bc11\n  bb-w24pt12 bb-sm-w30 bb-mid-w42",on:{"click":function($event){$event.stopPropagation();}}},[(!_vm.userLoggedIn)?_c('div',{staticClass:"center pt2 bb-ff3 bb-fs1pt2 bb-fc16"},[_vm._v(_vm._s(_vm.$lang.messages.verify_account))]):_vm._e(),_vm._v(" "),(_vm.userLoggedIn)?_c('div',{staticClass:"center pt2 bb-ff2 bb-fs1pt2 bb-fc2"},[_vm._v(_vm._s(_vm.$lang.messages.payment_process))]):_vm._e(),_vm._v(" "),(!_vm.userLoggedIn && !_vm.showVerificationCode)?_c('div',{staticClass:"center mt1 bb-ff2 bb-fc15"},[_vm._v(_vm._s(_vm.$lang.messages.payment_sbtitle))]):_vm._e(),_vm._v(" "),(_vm.showVerificationCode)?_c('div',{staticClass:"center mt1 bb-ff2 bb-fc15"},[_vm._v(_vm._s(_vm.$lang.messages.token_noti))]):_vm._e(),_vm._v(" "),(!_vm.userLoggedIn)?_c('div',{staticClass:"center bb-ff2 mt1"},[(!_vm.hideFields)?_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col col-12 md-col-6 bb-md-pr0pt5 border-box bb-mt1pt5 relative"},[_c('div',{staticClass:"absolute left-0 bb-top1 bb-transform1 pl2 bb-zindexn1 bb-fc14 bb-ff2",class:{'bb-transform3': _vm.inputFirstNameActive}},[_vm._v(_vm._s(_vm.$lang.messages.p1))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.first_name),expression:"userInfo.first_name"}],staticClass:"bb-bc-transp bb-md-right\n            border-box pl2 bb-ff2 bb-fs1 bb-w100p bb-h2pt8 bb-brd-left0\n            bb-brd-right0 bb-brd-top0",class:[ _vm.formSend && _vm.userInfo.first_name === '' ? 'bb-brd5' :
            'bb-brd-bot2 bb-fc16'],attrs:{"type":"text"},domProps:{"value":(_vm.userInfo.first_name)},on:{"blur":_vm.blurFirstNamePlaceholder,"change":_vm.resetValidation,"focus":_vm.inputFirstNameClicked,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo, "first_name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col col-12 md-col-6 bb-md-pl0pt5 border-box bb-mt1pt5 relative"},[_c('div',{staticClass:"absolute left-0 bb-top1 bb-transform1 pl2 bb-md-pl1pt5 bb-zindexn1 bb-fc14 bb-ff2",class:{'bb-transform3': _vm.inputLastNameActive}},[_vm._v(_vm._s(_vm.$lang.messages.p7))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.last_name),expression:"userInfo.last_name"}],staticClass:"bb-bc-transp bb-md-right\n            border-box pl2 bb-ff2 bb-fs1 bb-w100p bb-h2pt8 bb-brd-left0\n            bb-brd-right0 bb-brd-top0",class:[ _vm.formSend && _vm.userInfo.last_name === '' ? 'bb-brd5' :
            'bb-brd-bot2 bb-fc16'],attrs:{"type":"text"},domProps:{"value":(_vm.userInfo.last_name)},on:{"blur":_vm.blurLastNamePlaceholder,"change":_vm.resetValidation,"focus":_vm.inputLastNameClicked,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo, "last_name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col col-12 md-col-6 bb-md-pr0pt5 border-box bb-mt1pt5 relative"},[_c('div',{staticClass:"absolute left-0 bb-top1 bb-transform1 pl2 bb-zindexn1 bb-fc14 bb-ff2",class:{'bb-transform3': _vm.inputNumberActive}},[_vm._v(_vm._s(_vm.$lang.messages.p2))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.phone_number),expression:"userInfo.phone_number"}],staticClass:"bb-bc-transp bb-md-left border-box\n            pl2 bb-ff2 bb-fs1 bb-w100p bb-h2pt8 bb-brd-left0\n            bb-brd-right0 bb-brd-top0",class:[_vm.invalidPhoneNumber ? 'bb-brd5 bb-fc5' : 'bb-brd-bot2 bb-fc16'],attrs:{"type":"text"},domProps:{"value":(_vm.userInfo.phone_number)},on:{"blur":_vm.blurNumberPlaceholder,"focus":_vm.inputNumberClicked,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo, "phone_number", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col col-12 md-col-6 bb-md-pl0pt5 bb-mt1pt5 relative"},[_c('div',{staticClass:"absolute left-0 bb-top1 bb-transform1 pl2 bb-md-pl1pt5 bb-zindexn1 bb-fc14 bb-ff2",class:{'bb-transform3': _vm.inputMailActive}},[_vm._v(_vm._s(_vm.$lang.messages.p3))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.email),expression:"userInfo.email"}],staticClass:"bb-bc-transp border-box pl2\n            bb-ff2 bb-fs1 bb-w100p bb-h2pt8 bb-brd-left0\n            bb-brd-right0 bb-brd-top0",class:[_vm.invalidEmail ? 'bb-brd5 bb-fc5' : 'bb-brd-bot2 bb-fc16'],attrs:{"type":"text"},domProps:{"value":(_vm.userInfo.email)},on:{"blur":_vm.blurMailPlaceholder,"focus":_vm.inputMailClicked,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col col-12 mt2 bb-ff2 bb-fs1 bb-fc3\n        left-align"},[_vm._v("\n          "+_vm._s(_vm.$lang.messages.fill_require)+"\n        ")])]):_vm._e(),_vm._v(" "),((_vm.hideFields && !_vm.showVerificationCode))?_c('div',{staticClass:"relative bb-min-h10"},[_c('img',{staticClass:"absolute bb-vhcr bb-w5 bb-h5",attrs:{"src":__webpack_require__("OTU4")}})]):_vm._e(),_vm._v(" "),(_vm.showVerificationCode)?_c('div',{staticClass:"mt2 bb-min-h8"},[_c('div',{staticClass:"relative mt3"},[_c('div',{staticClass:"absolute left-0 bb-top1 bb-transform1 bb-zindexn1 bb-fc14 bb-ff2 bb-w100p",class:{'bb-op0': _vm.inputCodeActive}},[_vm._v(_vm._s(_vm.$lang.messages.p4))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.verification_code),expression:"userInfo.verification_code"}],ref:"code",staticClass:"bb-bc-transp border-box center  \n            bb-ff2 bb-fs1 bb-w100p bb-h2pt8 bb-brd-left0\n              bb-brd-right0 bb-brd-top0",class:[ (_vm.codeSend && _vm.userInfo.verification_code === '') ||
            _vm.invalidCode ? 'bb-brd5 bb-fc5' : 'bb-brd-bot2 bb-fc16'],attrs:{"type":"text"},domProps:{"value":(_vm.userInfo.verification_code)},on:{"blur":_vm.blurCodePlaceholder,"change":_vm.resetValidation,"focus":_vm.inputCodeClicked,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo, "verification_code", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"bb-mt1pt2 bb-ff2 bb-fs1 bb-fc3 left-align"},[_vm._v("\n          "+_vm._s(_vm.$lang.messages.fill_require)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"mt2 left-align"},[_c('div',{staticClass:"inline-block bb-brd-left0\n            bb-brd-right0 bb-brd-top0 bb-pointer bb-brd-bot2 bb-fc14 bb-ff2",on:{"click":_vm.resendCode}},[_vm._v("Resend Code")])])]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.showVerificationCode && !_vm.userLoggedIn)?_c('div',{staticClass:"center mx-auto border-box bb-pointer bb-bc2-hover bb-bc2 bb-sm-bc-transp\n      bb-ff3 bb-fs1 bb-fc1 bb-sm-fc2 bb-fc1-hover bb-brd3\n      bb-h2pt8 bb-py1pt25 bb-lh0 bb-transition2 bb-mt2pt6",on:{"click":_vm.sendCode}},[_vm._v("\n      "+_vm._s(_vm.$lang.messages.request_code)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.paymentBtn)?_c('div',{staticClass:"center mx-auto border-box bb-pointer bb-bc2-hover bb-bc2 bb-sm-bc-transp\n      bb-ff3 bb-fs1 bb-fc1 bb-sm-fc2 bb-fc1-hover bb-brd3\n      bb-h2pt8 bb-py1pt25 bb-lh0 bb-transition2 bb-mt3pt56 relative",on:{"click":_vm.checkout}},[_vm._v("\n        "+_vm._s(_vm.$lang.messages.verify_account)+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"center bb-mt1pt3 bb-ff3 bb-pointer mb1 bb-transition2\n     bb-fc8-hover bb-h1pt5 bb-lh1pt5 bb-fc14",class:[
     _vm.cancelTransitionClass, _vm.cancelBtnHighlighted ? 'bb-scale-1pt2' : '' ],on:{"click":_vm.cancelPayment}},[_vm._v(_vm._s(_vm.$lang.messages.cancel))]),_vm._v(" "),(_vm.showVerificationCode)?_c('div',{staticClass:"absolute bb-pointer bb-top3 bb-left2 bb-mln0pt6",on:{"click":_vm.paymentBack}},[_c('i',{staticClass:"bb-fc14 material-icons bb-fs2pt17 bb-usnone"},[_vm._v("")])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AIlL":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNy4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSIyMy42cHgiDQoJIGhlaWdodD0iMTkuMTg4cHgiIHZpZXdCb3g9IjAgMCAyMy42IDE5LjE4OCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMjMuNiAxOS4xODgiIHhtbDpzcGFjZT0icHJlc2VydmUiIGZpbGw9IiNmZjMzNjQiPg0KPGcgaWQ9IkxheWVyXzIiPg0KPC9nPg0KPGcgaWQ9IkxheWVyXzEiPg0KPC9nPg0KPGcgaWQ9Ikd1aWRlIj4NCgk8Zz4NCgkJPGc+DQoJCQk8cGF0aCBkPSJNMjMuNiwyLjI2OWMtMC44NjUsMC4zODQtMS44MDEsMC42NDktMi43OCwwLjc2NmMxLjAwMS0wLjYsMS43NjQtMS41NSwyLjEzMS0yLjY4M2MtMC45MzcsMC41NTUtMS45NzMsMC45Ni0zLjA4MywxLjE3NQ0KCQkJCUMxOC45OTEsMC41OSwxNy43MywwLDE2LjM0LDBjLTIuNjcxLDAtNC44NCwyLjE3LTQuODQsNC44NDRjMCwwLjM4MiwwLjA0NCwwLjc0OSwwLjEyNCwxLjEwNA0KCQkJCWMtNC4wMjYtMC4yMDMtNy41OS0yLjEyOC05Ljk4Mi01LjA2MkMxLjIyNCwxLjYsMC45ODYsMi40MzYsMC45ODYsMy4zMjNjMCwxLjY3OSwwLjg1NywzLjE2NSwyLjE1Myw0LjAyOA0KCQkJCWMtMC43OTMtMC4wMi0xLjUzNC0wLjI0My0yLjE4OC0wLjYwNXYwLjA1OWMwLDIuMzQ5LDEuNjcsNC4zMDksMy44ODEsNC43NTdjLTAuNDA0LDAuMTA3LTAuODM1LDAuMTY0LTEuMjc0LDAuMTY0DQoJCQkJYy0wLjMxLDAtMC42MTItMC4wMjgtMC45MTQtMC4wODVjMC42MTksMS45MjUsMi40MDQsMy4zMjIsNC41MjIsMy4zNjZjLTEuNjU3LDEuMjk3LTMuNzQ2LDIuMDY5LTYuMDE0LDIuMDY5DQoJCQkJYy0wLjM4OSwwLTAuNzcxLTAuMDIyLTEuMTUyLTAuMDY1YzIuMTQ2LDEuMzc3LDQuNjg4LDIuMTc2LDcuNDI0LDIuMTc2YzguOTAxLDAsMTMuNzctNy4zODEsMTMuNzctMTMuNzgxTDIxLjE4LDQuNzc5DQoJCQkJQzIyLjEzMSw0LjA5NCwyMi45NTEsMy4yNDQsMjMuNiwyLjI2OUwyMy42LDIuMjY5eiIvPg0KCQk8L2c+DQoJPC9nPg0KPC9nPg0KPGcgaWQ9IkxheWVyXzQiIGRpc3BsYXk9Im5vbmUiPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ "AX7B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AZPM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var validator = __webpack_require__("WWPA");
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'loginModal',
  props: ['loginData'],
  data: function data() {
    return {
      showVerificationCode: false,
      hideFields: false,
      payfortEnabled: false,
      inputFirstNameActive: false,
      inputLastNameActive: false,
      inputNumberActive: false,
      inputMailActive: false,
      inputCodeActive: false,
      showArrow: false,
      formSend: false,
      userInfo: {
        phone_number: '',
        first_name: '',
        last_name: '',
        email: '',
        verification_code: ''
      },
      invalidEmail: false,
      codeSend: false,
      cancelTransitionClass: 'bb-transition2',
      cancelBtnHighlighted: false,
      invalidCode: false,
      invalidPhoneNumber: false
    };
  },

  computed: {
    userToken: function userToken() {
      if (this.$store.getters.getUserToken) {
        return this.$store.getters.getUserToken;
      }
    },
    paymentBtn: function paymentBtn() {
      if (this.showVerificationCode || this.userLoggedIn) {
        return true;
      }
    },
    tokenError: function tokenError() {
      return this.$store.getters.getTokenError;
    },
    phoneError: function phoneError() {
      return this.$store.getters.getPhoneError;
    },
    userLoggedOut: function userLoggedOut() {
      return this.$store.getters.getLoggedIn;
    },
    userCredentials: function userCredentials() {
      return this.$store.getters.getUserCredentials;
    }
  },
  watch: {
    userToken: function userToken() {
      if (this.$store.getters.getUserToken) {
        if (this.hideFields) {
          this.showVerificationCode = true;
          this.$nextTick(function () {
            this.$refs.code.focus();
            this.inputCodeActive = true;
          });
        }
      }
    },
    'userInfo.verification_code': function userInfoVerification_code() {
      if (this.codeSend) {
        this.codeSend = false;
      }
      if (this.invalidCode) {
        this.invalidCode = false;
      }
    },
    tokenError: function tokenError() {
      this.invalidCode = true;
      this.$emit('emitNotification', this.$lang.messages.err4);
    },
    phoneError: function phoneError() {
      this.invalidPhoneNumber = true;
      this.hideFields = false;
      this.$emit('emitNotification', this.$lang.messages.err5);
    },
    'userInfo.phone_number': function userInfoPhone_number() {
      if (this.invalidPhoneNumber) {
        this.invalidPhoneNumber = false;
      }
    },
    'userInfo.email': function userInfoEmail() {
      if (this.invalidEmail) {
        this.invalidEmail = false;
      }
    },
    userLoggedOut: function userLoggedOut() {
      if (!this.$store.getters.getLoggedIn) {
        this.userInfo.verification_code = '';
        this.userInfo.first_name = '';
        this.userInfo.last_name = '';
        this.userInfo.phone_number = '';
        this.userInfo.email = '';
        this.showVerificationCode = false;
        this.showArrow = false;
      }
    },
    userCredentials: function userCredentials() {
      this.$localStorage.set('token', this.$store.getters.getUserCredentials.profileToken);
      this.$localStorage.set('profileId', this.$store.getters.getUserCredentials.profileId);
      this.$localStorage.set('username', this.$store.getters.getUserCredentials.username);
      this.$store.commit('SET_LOGGEDIN', true);
      this.$store.commit('SET_SHOW_MODAL', false);
    }
  },
  methods: {
    getParameterByName: function getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
    paymentBack: function paymentBack() {
      this.showVerificationCode = false;
      this.hideFields = false;
    },
    sendCode: function sendCode() {
      this.formSend = true;
      if (this.userInfo.first_name !== '' && this.userInfo.last_name !== '' && this.userInfo.phone_number !== '' && this.userInfo.email) {
        if (validator.validate(this.userInfo.email)) {
          this.hideFields = true;
          var params = {
            first_name: this.userInfo.first_name,
            last_name: this.userInfo.last_name,
            email: this.userInfo.email,
            phone_number: this.userInfo.phone_number,
            via: 'sms' };
          this.$store.dispatch('LOAD_USER_TOKEN', params);
        } else {
          this.invalidEmail = true;
          this.$emit('emitNotification', this.$lang.messages.err2);
        }
      } else {
        if (this.userInfo.phone_number === '') {
          this.invalidPhoneNumber = true;
        }
        if (this.userInfo.email === '') {
          this.invalidEmail = true;
        }
        this.$emit('emitNotification', this.$lang.messages.err3);
      }
    },
    resendCode: function resendCode() {
      var params = {
        first_name: this.userInfo.first_name,
        last_name: this.userInfo.last_name,
        email: this.userInfo.email,
        phone_number: this.userInfo.phone_number,
        via: 'sms' };
      this.$store.dispatch('LOAD_USER_TOKEN', params);
    },
    cancelPayment: function cancelPayment() {
      this.showVerificationCode = false;
      this.hideFields = false;
      this.invalidCode = false;
      this.codeSend = false;
      this.invalidEmail = false;
      this.formSend = false;
      this.showArrow = false;
      this.invalidPhoneNumber = false;
      this.$store.commit('SET_USER_TOKEN', null);
      this.$store.commit('SET_SHOW_MODAL', false);
      this.$emit('cancelLoginEmit');
    },
    resetValidation: function resetValidation(event) {
      if (this.formSend) {
        this.formSend = false;
      }
      if (this.invalidEmail) {
        this.invalidEmail = false;
      }
      if (this.invalidPhoneNumber) {
        this.invalidPhoneNumber = false;
      }
    },
    highlightCancelBtn: function highlightCancelBtn() {
      this.cancelBtnHighlighted = true;
      var self = this;
      setTimeout(function () {
        self.cancelBtnHighlighted = false;
      }, this.$utilities.getTransitionDurationOfClass('.' + this.cancelTransitionClass) * 1000);
    },
    validateNumber: function validateNumber(val) {
      return (/^\d+$/.test(val)
      );
    },
    resetPlaceholder: function resetPlaceholder(event, placeholder) {
      event.target.placeholder = placeholder;
    },
    blurFirstNamePlaceholder: function blurFirstNamePlaceholder(event) {
      if (event.target.value.length <= 0) {
        this.inputFirstNameActive = false;
      }
    },
    blurLastNamePlaceholder: function blurLastNamePlaceholder(event) {
      if (event.target.value.length <= 0) {
        this.inputLastNameActive = false;
      }
    },
    blurNumberPlaceholder: function blurNumberPlaceholder(event) {
      if (event.target.value.length <= 0) {
        this.inputNumberActive = false;
      }
    },
    blurMailPlaceholder: function blurMailPlaceholder(event) {
      if (event.target.value.length <= 0) {
        this.inputMailActive = false;
      }
    },
    blurCodePlaceholder: function blurCodePlaceholder(event) {
      if (event.target.value.length <= 0) {
        this.inputCodeActive = false;
      }
    },
    checkout: function checkout() {
      this.$store.commit('SET_USER_INFO', this.userInfo);
      this.$store.dispatch('LOAD_TOKEN', this.userInfo);
    },
    inputFirstNameClicked: function inputFirstNameClicked() {
      this.inputFirstNameActive = true;
    },
    inputLastNameClicked: function inputLastNameClicked() {
      this.inputLastNameActive = true;
    },
    inputNumberClicked: function inputNumberClicked() {
      this.inputNumberActive = true;
    },
    inputMailClicked: function inputMailClicked() {
      this.inputMailActive = true;
    },
    inputCodeClicked: function inputCodeClicked() {
      this.inputCodeActive = true;
    }
  },
  mounted: function mounted() {
    this.payfortEnabled = this.getParameterByName('payfort') === 'true';
  }
});

/***/ }),

/***/ "CxV2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative bb-ofx-hidden bb-min-h100p flex flex-column",class:[this.$router.history.current.meta.bgBlack ? 'bb-bc-black' :
'bb-bc12', (_vm.showModal || _vm.showLogoutModal) ? 'fixed top-0 right-0 left-0' : ''],attrs:{"id":"app"}},[_c('top',{attrs:{"id":"header"}}),_vm._v(" "),_c('router-view',{key:_vm.$route.fullPath,staticClass:"content border-box bb-w100p bb-fullscreen bb-fl1",staticStyle:{"margin-bottom":"8rem"}}),_vm._v(" "),_c('bot',{staticClass:"flex-none",attrs:{"id":"footer"}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showModal)?_c('login-modal',{attrs:{"loginData":_vm.selectedOptions},on:{"cancelLoginEmit":_vm.cancelLogin,"emitNotification":_vm.displayNoti}}):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showLogoutModal)?_c('logout-modal',{on:{"cancelLogoutEmit":_vm.cancelLogout}}):_vm._e()],1),_vm._v(" "),(_vm.displayNotification)?_c('mini-notification',{staticClass:"bb-fullscreen",class:[ _vm.displayNotification.show ? 'top-0 bb-visible' : 'bb-topn2pt5 bb-hidden' ],attrs:{"msg":_vm.displayNotification.msg,"success":_vm.displayNotification.state}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Cz8s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__("wqBJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b630a42_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__("TOkl");
function injectStyle (ssrContext) {
  __webpack_require__("KDCt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8b630a42"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b630a42_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DIKo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loginModal_vue__ = __webpack_require__("AZPM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29a9a00c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loginModal_vue__ = __webpack_require__("8y3W");
function injectStyle (ssrContext) {
  __webpack_require__("Eg9V")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-29a9a00c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loginModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29a9a00c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loginModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Dwzj":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "E+QB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PrivacyPolicy',
  data: function data() {
    return {
      scrollView: null
    };
  },

  methods: {
    scrollViewScrolled: function scrollViewScrolled(event) {
      this.toggleGradient(event.target);
    },
    scrolledToEnd: function scrolledToEnd(el) {
      return el.scrollHeight - el.scrollTop <= el.clientHeight;
    },
    resized: function resized() {
      this.calcScrollViewMaxHeight(this.scrollView);
      this.toggleGradient(this.scrollView);
    },
    calcScrollViewMaxHeight: function calcScrollViewMaxHeight(el) {
      var windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
      var scrollViewY = el.getBoundingClientRect().top;
      var footerHeight = document.getElementById('footer').offsetHeight;
      var pageMarginBottom = 8 * parseFloat(getComputedStyle(document.documentElement).fontSize);
      el.style.maxHeight = windowHeight - scrollViewY - footerHeight - pageMarginBottom + 'px';
    },
    toggleGradient: function toggleGradient(el) {
      if (this.scrolledToEnd(el)) {
        document.getElementById('scrollGradient').classList.add('bb-op0');
      } else {
        document.getElementById('scrollGradient').classList.remove('bb-op0');
      }
    }
  },
  mounted: function mounted() {
    this.scrollView = document.getElementById('scrollView');
    this.scrollView.addEventListener('scroll', this.scrollViewScrolled);

    window.addEventListener('resize', this.resized);

    this.calcScrollViewMaxHeight(this.scrollView);
    this.toggleGradient(this.scrollView);
  },
  destroyed: function destroyed() {
    this.scrollView.removeEventListener('scroll', this.scrollViewScrollEnd);
    window.removeEventListener('resize', this.resized);
  }
});

/***/ }),

/***/ "Eg9V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FGQs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_slider__ = __webpack_require__("7d4M");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  components: {
    'slider': __WEBPACK_IMPORTED_MODULE_0__components_slider__["a" /* default */]
  },
  data: function data() {
    return {
      bookSessionHighlighted: false,
      bookSessionTransitionClass: 'bb-transition2',
      hoveredIndex: 0,
      sliderRender: false
    };
  },

  methods: {
    highlightBookSession: function highlightBookSession() {
      this.bookSessionHighlighted = true;
      var self = this;
      setTimeout(function () {
        self.bookSessionHighlighted = false;
      }, this.$utilities.getTransitionDurationOfClass('.' + this.bookSessionTransitionClass) * 1000);
    },
    recieveSlidePosterClicked: function recieveSlidePosterClicked() {
      this.highlightBookSession();
    },
    loadListId: function loadListId() {
      this.$store.commit('SET_ITEMS', null);
      this.sliderRender = false;
      if (this.listId) {
        this.$store.dispatch('LOAD_ITEMS', this.listId);
      }
    },
    hoverTab: function hoverTab(index) {
      this.hoveredIndex = index;
    },
    resetHoverTab: function resetHoverTab() {
      this.hoveredIndex = 0;
    },
    sliderReady: function sliderReady() {
      this.sliderRender = true;
    }
  },
  computed: {
    homeData: function homeData() {
      return this.$store.getters.getHomeData;
    },
    listId: function listId() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      }

      if (this.homeData && this.homeData.length) {
        return this.homeData[0].value._id;
      }

      return '';
    },
    listName: function listName() {
      if (this.$route.params.name) {
        return this.$route.params.name;
      }

      if (this.homeData && this.homeData.length) {
        return this.homeData[0].doc.name;
      }

      return '';
    },
    playlistItems: function playlistItems() {
      return this.$store.getters.getItems;
    }
  },

  watch: {
    'listId': {
      handler: 'loadListId',
      immediate: true
    }
  },

  created: function created() {
    /* this component is re-initialized everytime a new tab
       is selected, and there is no point reloading the actual
       schedule */
    if (!this.homeData) {
      this.$store.dispatch('LOAD_SCHEDULE', 'home');
    }
  }
});

/***/ }),

/***/ "GPP4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H0Ad":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bigbang-logo02.ed6bb8e.svg";

/***/ }),

/***/ "HH8T":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNy4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHdpZHRoPSIxMC40ODlweCIgaGVpZ2h0PSIyMi40NzRweCIgdmlld0JveD0iMCAwIDEwLjQ4OSAyMi40NzQiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDEwLjQ4OSAyMi40NzQiIHhtbDpzcGFjZT0icHJlc2VydmUiIGZpbGw9IiNmZjMzNjQiPg0KPGcgaWQ9IkxheWVyXzIiPg0KPC9nPg0KPGcgaWQ9IkxheWVyXzEiPg0KPC9nPg0KPGcgaWQ9Ikd1aWRlIj4NCgk8Zz4NCgkJPGc+DQoJCQk8cGF0aCBkPSJNMi4yNjcsNC4zNTN2My4wOTNIMHYzLjc4NGgyLjI2N3YxMS4yNDVoNC42NTdWMTEuMjMxaDMuMTI1YzAsMCwwLjI5My0xLjgxNCwwLjQzNi0zLjc5OEg2Ljk0MlY0Ljg0NQ0KCQkJCWMwLTAuMzg2LDAuNTA3LTAuOTA2LDEuMDEtMC45MDZoMi41MzdWMEg3LjAzOEMyLjE1MiwwLDIuMjY3LDMuNzg3LDIuMjY3LDQuMzUzTDIuMjY3LDQuMzUzeiIvPg0KCQk8L2c+DQoJPC9nPg0KPC9nPg0KPGcgaWQ9IkxheWVyXzQiIGRpc3BsYXk9Im5vbmUiPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ "Hpn/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper-container"},[_vm._t("parallax-bg"),_vm._v(" "),_c('div',{class:_vm.defaultSwiperClasses.wrapperClass},[_vm._t("default")],2),_vm._v(" "),_vm._t("pagination"),_vm._v(" "),_vm._t("button-prev"),_vm._v(" "),_vm._t("button-next"),_vm._v(" "),_vm._t("scrollbar")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "J0Mm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_booking_vue__ = __webpack_require__("f55A");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_affb746a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_booking_vue__ = __webpack_require__("ZCRR");
function injectStyle (ssrContext) {
  __webpack_require__("GPP4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-affb746a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_booking_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_affb746a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_booking_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KDCt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KeMG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirmation_vue__ = __webpack_require__("acFv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ee9ffb0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_confirmation_vue__ = __webpack_require__("L/QO");
function injectStyle (ssrContext) {
  __webpack_require__("fDzi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9ee9ffb0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirmation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ee9ffb0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_confirmation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KsxP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute top-0 left-0 bb-zindex1 bb-bc10 bb-h100vh bb-w100vw bb-fullscreen bb-usnone",on:{"click":_vm.highlightCancelBtn}},[_c('div',{staticClass:"mx-auto relative bb-vcr bb-br5 border-box p3 bb-bc11\n  bb-w24pt12 bb-sm-w30 bb-mid-w35",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"center pt2 bb-ff3 bb-fs1pt2 bb-fc16"},[_vm._v(_vm._s(_vm.$lang.messages.logout_verification))]),_vm._v(" "),_c('div',{staticClass:"clearfix center mt2"},[_c('div',{staticClass:"center mx-auto border-box bb-pointer bb-bc2-hover bb-bc2 bb-sm-bc-transp\n        bb-ff3 bb-fs1 bb-fc1 bb-sm-fc2 bb-fc1-hover bb-brd3\n        bb-h2pt8 bb-py1pt25 bb-lh0 bb-transition2 bb-mt2pt6",on:{"click":_vm.confirmLogout}},[_vm._v("\n        "+_vm._s(_vm.$lang.messages.user_logout)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"center mt2 bb-fc2 bb-ff3 bb-pointer mb1 bb-transition2\n       bb-fc8-hover bb-h1pt5 bb-lh1pt5 bb-fc14",class:[
       _vm.cancelTransitionClass, _vm.cancelBtnHighlighted ? 'bb-scale-1pt2' : ''
       ],on:{"click":_vm.cancelLogout}},[_vm._v(_vm._s(_vm.$lang.messages.cancel))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "L/QO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[(_vm.userLoggedIn && _vm.loading)?_c('div',[_c('div',{staticClass:"bb-ff2 bb-fs1pt2 bb-fc1 mt4"},[_vm._v(_vm._s(_vm.$lang.messages.loading))]),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1 bb-fc3 mt1"},[_vm._v(_vm._s(_vm.$lang.messages.loading_submsg1))]),_vm._v(" "),_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.paymentError)?_c('div',[_c('div',{staticClass:"bb-ff2 bb-fs1pt2 bb-fc5 mt4"},[_vm._v(_vm._s(_vm.$lang.messages.sorry))]),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1 bb-fc3 mt1"},[_vm._v(_vm._s(_vm.$lang.messages.conf_err_submsg1))]),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1 bb-fc3 mt1"},[_vm._v(_vm._s(_vm.$lang.messages.conf_err_submsg2))]),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1 bb-fc1 mt2"},[_vm._v("or")]),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1 bb-fc3 mt1"},[_vm._v(_vm._s(_vm.$lang.messages.conf_err_submsg3))]),_vm._v(" "),_c('div',{staticClass:"bb-mt2pt56 mx-auto bb-w12"},[_c('router-link',{staticClass:"text-decoration-none border-none",attrs:{"to":"/"}},[_c('div',{staticClass:"center mx-auto border-box bb-pointer bb-bc2-hover bb-bc2 bb-sm-bc-transp\n        bb-ff3 bb-fs1 bb-fc1 bb-sm-fc2 bb-fc1-hover bb-brd3 bb-h2pt5 bb-py1pt25 bb-lh0\n        bb-transition2"},[_vm._v("\n        "+_vm._s(_vm.$lang.messages.done)+"\n        ")])])],1)]):_vm._e(),_vm._v(" "),(_vm.voucherPayment || _vm.gatewayPaymentSuccess)?_c('div',[_c('div',{staticClass:"bb-ff2 bb-fs1pt2 bb-fc1 mt4"},[_vm._v(_vm._s(_vm.$lang.messages.thank_you))]),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1 bb-fc3 mt1"},[_vm._v(_vm._s(_vm.$lang.messages.success_submsg1))]),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1 bb-fc1 mt1"},[_vm._v(_vm._s(_vm.selectedOptions.experienceName)+" experience, "+_vm._s(_vm.selectedOptions.timestamp))]),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1 bb-fc3 mt2"},[_vm._v(_vm._s(_vm.$lang.messages.success_submsg2))]),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1 bb-fc1 mt1"},[_vm._v(_vm._s(_vm.userInfo.email))]),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1 bb-fc3 mt1"},[_vm._v(_vm._s(_vm.$lang.messages.success_submsg3))]),_vm._v(" "),(_vm.gatewayPaymentSuccess)?_c('div',{staticClass:"bb-ff2 bb-fs1 bb-fc1 mt1"},[_vm._v(_vm._s(_vm._f("referenceId")(_vm.bookingActivity[0].id)))]):_vm._e(),_vm._v(" "),(_vm.voucherPayment)?_c('div',{staticClass:"bb-ff2 bb-fs1 bb-fc1 mt1"},[_vm._v(_vm._s(_vm._f("referenceId")(_vm.voucherFeedback.id)))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bb-mt2pt56 mx-auto bb-w12"},[_c('router-link',{staticClass:"text-decoration-none border-none",attrs:{"to":"/"}},[_c('div',{staticClass:"center mx-auto border-box bb-pointer bb-bc2-hover bb-bc2 bb-sm-bc-transp\n        bb-ff3 bb-fs1 bb-fc1 bb-sm-fc2 bb-fc1-hover bb-brd3 bb-h2pt5 bb-py1pt25 bb-lh0\n        bb-transition2"},[_vm._v("\n        "+_vm._s(_vm.$lang.messages.done)+"\n        ")])])],1)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt4"},[_c('img',{staticClass:"bb-w5 bb-h5",attrs:{"src":__webpack_require__("OTU4")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LEfX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px3"},[_c('div',{staticClass:"bb-h60vh"},[_c('div',{staticClass:"center clearfix relative bb-vcr"},[_c('div',{staticClass:"bb-ff2 bb-fs2pt17 bb-fc1"},[_vm._v("FAILED")]),_vm._v(" "),_c('div',{staticClass:"mt2 bb-ff2 bb-fs1pt13 bb-fc3 bb-lh1pt5 bb-mx2 bb-sm-mx10 bb-md-mx1"},[_vm._v("\n        "+_vm._s(_vm.$lang.messages.pay_app)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"bb-mt2pt56 mx-auto bb-w12"},[_c('router-link',{staticClass:"text-decoration-none border-none",attrs:{"to":"/"}},[_c('div',{staticClass:"center mx-auto border-box bb-pointer bb-bc2-hover bb-bc2 bb-sm-bc-transp\n          bb-ff3 bb-fs1 bb-fc1 bb-sm-fc2 bb-fc1-hover bb-brd3 bb-h2pt5 bb-py1pt25 bb-lh0\n          bb-transition2"},[_vm._v("\n          "+_vm._s(_vm.$lang.messages.retry)+"\n          ")])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LIyj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_miniNotification_vue__ = __webpack_require__("0sfo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf5e01f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_miniNotification_vue__ = __webpack_require__("mYO3");
function injectStyle (ssrContext) {
  __webpack_require__("AX7B")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bf5e01f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_miniNotification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf5e01f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_miniNotification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_725c99de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("CxV2");
function injectStyle (ssrContext) {
  __webpack_require__("Mg1S")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_725c99de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mg1S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N+zL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_slide_vue__ = __webpack_require__("+p9J");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_115f7cdb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_slide_vue__ = __webpack_require__("OcrF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_slide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_115f7cdb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_slide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "N4Va":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkout_vue__ = __webpack_require__("yuJj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1da84679_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkout_vue__ = __webpack_require__("z0aN");
function injectStyle (ssrContext) {
  __webpack_require__("+vZe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1da84679"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1da84679_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NBqp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_paymentSuccessful_vue__ = __webpack_require__("hPsX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e6705b3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_paymentSuccessful_vue__ = __webpack_require__("0EzP");
function injectStyle (ssrContext) {
  __webpack_require__("0rhx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e6705b3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_paymentSuccessful_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e6705b3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_paymentSuccessful_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities__ = __webpack_require__("UQw1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuejs_localization__ = __webpack_require__("Fmni");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuejs_localization___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuejs_localization__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_localstorage__ = __webpack_require__("UnSZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_localstorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_css_base_css__ = __webpack_require__("dNEa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_css_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__src_css_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__node_modules_material_design_icons_iconfont_material_icons_css__ = __webpack_require__("uTBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__node_modules_material_design_icons_iconfont_material_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__node_modules_material_design_icons_iconfont_material_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_swiper_dist_css_swiper_css__ = __webpack_require__("v2ns");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_swiper_dist_css_swiper_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.













var VERSION = '1.0.0';

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3__utilities__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper___default.a);
__WEBPACK_IMPORTED_MODULE_7_vuejs_localization___default.a.requireAll(__webpack_require__("apj+"));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vuejs_localization___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_localstorage___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin({
  methods: {
    logout: function logout() {
      this.$store.commit('SET_SHOW_LOGOUT_MODAL', true);
    },
    forceLogin: function forceLogin() {
      if (this.userLoggedIn) {
        this.pendingForceLogin = false;
      } else {
        if (!this.showLoginModal) {
          if (!this.pendingForceLogin) {
            this.pendingForceLogin = true;
            this.$store.commit('SET_SHOW_MODAL', true);
          } else {
            this.pendingForceLogin = false;
            this.$router.push({ name: 'Home' });
          }
        }
      }
    }
  },
  computed: {
    showLoginModal: function showLoginModal() {
      return this.$store.getters.getShowModal;
    },
    userLoggedIn: function userLoggedIn() {
      return this.$store.getters.getLoggedIn;
    }
  },
  data: function data() {
    return {
      pendingForceLogin: false
    };
  },

  watch: {
    showLoginModal: function showLoginModal() {
      if (this.pendingForceLogin) {
        this.forceLogin();
      }
    }
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    var opts = __WEBPACK_IMPORTED_MODULE_6_qs___default.a.parse(window.location.search, {
      ignoreQueryPrefix: true
    });

    opts.language = 'english';

    if (opts.token && opts.profileId) {
      this.$localStorage.set('token', opts.token);
      this.$localStorage.set('profileId', opts.profileId);
      this.$localStorage.set('username', 'test');
    }

    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('INIT', {
      domain: 'bbangstudios.com',
      outlet: 'website',
      version: VERSION,
      opts: opts
    });
  }
});

/***/ }),

/***/ "O6or":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_paymentFail_vue__ = __webpack_require__("jx1M");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_370fd21a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_paymentFail_vue__ = __webpack_require__("LEfX");
function injectStyle (ssrContext) {
  __webpack_require__("uHdg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-370fd21a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_paymentFail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_370fd21a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_paymentFail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OCqi":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "OTU4":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSIzOCIgaGVpZ2h0PSIzOCIKICB2aWV3Qm94PSIwIDAgMzggMzgiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaW5ZTWluIG1lZXQiPgogIDxwYXRoIGZpbGw9IiNmZjMzNjQiIHN0cm9rZT0iI2ZmMzM2NCIgc3Ryb2tlLXdpZHRoPSIwLjYwMjciIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTUuMjAzLDIwIGMwLTguMTU5LDYuNjM4LTE0Ljc5NywKICAgIDE0Ljc5Ny0xNC43OTdWNUMxMS43MjksNSw1LDExLjcyOSw1LDIwczYuNzI5LDE1LDE1LDE1di0wLjIwM0MxMS44NDEsMzQuNzk3LDUuMjAzLDI4LjE1OSw1LjIwMywyMHoiPgogICAgPGFuaW1hdGVUcmFuc2Zvcm0gYXR0cmlidXRlTmFtZT0idHJhbnNmb3JtIiB0eXBlPSJyb3RhdGUiIGZyb209IjAgMjAgMjAiIHRvPSIzNjAgMjAgMjAiIGNhbGNNb2RlPSJzcGxpbmUiCiAgICAgIGtleVNwbGluZXM9IjAuNCwgMCwgMC4yLCAxIiBrZXlUaW1lcz0iMDsxIiBkdXI9IjFzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIvPiAgICAgIAogIDwvcGF0aD4KCiAgPHBhdGggZmlsbD0iI2ZmMzM2NCIgc3Ryb2tlPSIjZmYzMzY0IiBzdHJva2Utd2lkdGg9IjAuMjAyNyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBkPSJNNy4wNzgsMjAKICAgIGMwLTcuMTI1LDUuNzk3LTEyLjkyMiwxMi45MjItMTIuOTIyVjYuODc1QzEyLjc2Myw2Ljg3NSw2Ljg3NSwxMi43NjMsNi44NzUsMjBTMTIuNzYzLDMzLjEyNSwyMCwzMy4xMjV2LTAuMjAzCiAgICBDMTIuODc1LDMyLjkyMiw3LjA3OCwyNy4xMjUsNy4wNzgsMjB6Ij4KICAgIDxhbmltYXRlVHJhbnNmb3JtIGF0dHJpYnV0ZU5hbWU9InRyYW5zZm9ybSIgdHlwZT0icm90YXRlIiBmcm9tPSIwIDIwIDIwIiB0bz0iMzYwIDIwIDIwIiBkdXI9IjAuOHMiCiAgICAgIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIi8+CiAgPC9wYXRoPgo8L3N2Zz4="

/***/ }),

/***/ "OcrF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.slideClass},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PwwB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_privacyPolicy_vue__ = __webpack_require__("E+QB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50176303_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_privacyPolicy_vue__ = __webpack_require__("1hbY");
function injectStyle (ssrContext) {
  __webpack_require__("4Laz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50176303"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_privacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50176303_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_privacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Rhxi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"flex flex-wrap justify-center"},_vm._l((_vm.homeData),function(list,index){return _c('div',{staticClass:"px2"},[_c('router-link',{staticClass:"inline-block relative bb-pointer",attrs:{"to":{name:
      'Home', params: { id: list.value._id, name: list.doc.name}}}},[_c('div',{staticClass:"inline-block relative bb-pointer",on:{"mouseenter":function($event){_vm.hoverTab(index + 1)},"mouseleave":function($event){_vm.resetHoverTab()}}},[_c('div',{staticClass:"mt1 mb2 bb-fs1pt13 bb-sm-fs1pt5 bb-fc1",class:[ _vm.listId === list.value._id ? 'bb-ff3' : 'bb-ff2' ]},[_vm._v("\n            "+_vm._s(list.doc.name)+"\n          ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.listId === list.value._id),expression:"listId === list.value._id"}],staticClass:"absolute bottom-0 bb-hcr bb-w3 bb-h0pt2 bb-bc2"}),_vm._v(" "),_c('div',{staticClass:"absolute bottom-0 left-0 right-0 bb-h0pt2 bb-bc2 bb-scaleX-0 bb-transition2",class:[ _vm.hoveredIndex === (index + 1) ? 'bb-scaleX-1' : 'bb-scaleX-0' ]})])])],1)})),_vm._v(" "),_c('div',{staticClass:"bb-fullscreen relative bb-h28 bb-lg-h25 mt2 mb3"},[(!_vm.playlistItems || !_vm.sliderRender)?_c('img',{staticClass:"absolute bb-vhcr bb-w5 bb-h5",attrs:{"src":__webpack_require__("OTU4")}}):_vm._e(),_vm._v(" "),(_vm.playlistItems)?_c('slider',{directives:[{name:"show",rawName:"v-show",value:(_vm.sliderRender),expression:"sliderRender"}],attrs:{"sliderData":_vm.playlistItems},on:{"emitSlidePosterClicked":_vm.recieveSlidePosterClicked,"sliderRenderFinished":_vm.sliderReady}}):_vm._e()],1),_vm._v(" "),_c('div',[(_vm.listId)?_c('router-link',{staticClass:"block col-10 lg-col-2 bb-max-w34 mx-auto\n    text-decoration-none",attrs:{"to":{ name: 'Booking', params: {
      playlistId: _vm.listId, playlistName: _vm.listName}}}},[_c('div',{staticClass:"center bb-h2pt5 bb-py1pt25 bb-lh0 border-box bb-pointer bb-fc1 bb-sm-fc2 bb-fc1-hover\n        bb-bc2 bb-sm-bc-transp bb-bc2-hover bb-ff3 bb-fs1 bb-brd3",class:[ _vm.bookSessionTransitionClass, _vm.bookSessionHighlighted ? 'bb-scale-1pt1' : '' ]},[_vm._v("\n        "+_vm._s(_vm.$lang.messages.book_session)+"\n      ")])]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "S4JM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contact_vue__ = __webpack_require__("bBBi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51afe768_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contact_vue__ = __webpack_require__("zeKi");
function injectStyle (ssrContext) {
  __webpack_require__("lnS6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-51afe768"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51afe768_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SqJj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TOkl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bb-px2pt6 pb3 flex flex-wrap items-center border-box bb-w100p"},[_c('div',{staticClass:"col-12 lg-hide xl-hide mt2"}),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(this.$router.history.current.meta.showBackBtn),expression:"this.$router.history.current.meta.showBackBtn"}]},[_c('div',{staticClass:"bb-fc1 bb-fc2-hover bb-pointer bb-transition2\n          bb-ff2 text-decoration-none",on:{"click":function($event){_vm.$router.go(-1)}}},[_vm._m(0),_vm._v(" "),_c('span',{staticClass:"xs-hide sm-hide md-hide"},[_c('span',{staticClass:"align-middle bb-ff2 bb-fs1pt13"},[_vm._v("\n              Back\n              "),_c('span',{staticClass:"bb-fs0"},[_vm._v(_vm._s(_vm.$route.name))])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-4 flex justify-center"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"\n            xs-hide\n            sm-hide\n            md-hide\n            bb-h4pt5\n            bb-mt1pt2\n          ",attrs:{"src":__webpack_require__("H0Ad")}}),_vm._v(" "),_c('img',{staticClass:"\n            bb-w4\n            bb-sm-w5\n            pt1\n            lg-hide xl-hide\n        ",attrs:{"src":__webpack_require__("hEVc")}})])],1),_vm._v(" "),_c('div',{staticClass:"col-4 flex justify-end"},[(_vm.userLoggedIn)?_c('div',{staticClass:"\n          bb-fc1\n          bb-fc2-hover\n          bb-pointer\n          bb-transition2\n          bb-ff2\n        ",on:{"click":this.logout}},[_vm._v("\n        "+_vm._s(_vm.$lang.messages.logout)+"\n      ")]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"bb-mln0pt6"},[_c('i',{staticClass:"material-icons align-middle bb-fs2pt17"},[_vm._v("")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UQw1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var hasClass = function hasClass(el, cl) {
  return (' ' + el.className + ' ').indexOf(' ' + cl + ' ') > -1;
};

var getWidthOfClass = function getWidthOfClass(className) {
  var width = getClassStyle(className).width;
  if (width) {
    return parseStyleString(width);
  }
};

var getTransitionDurationOfClass = function getTransitionDurationOfClass(className) {
  var transition = getClassStyle(className).transitionDuration;
  if (transition) {
    return parseFloat(transition.substring(0, transition.length - 1));
  }
};

var parseStyleString = function parseStyleString(styleString) {
  var valueSubstring = '';
  var unitSubstring = '';
  for (var i in styleString) {
    if (!isNaN(styleString[i]) || styleString[i] === '.') {
      valueSubstring += styleString[i];
    } else {
      unitSubstring += styleString[i];
    }
  }
  return {
    value: parseFloat(valueSubstring),
    unit: unitSubstring
  };
};

var getClassStyle = function getClassStyle(className) {
  var styleSheets = window.document.styleSheets;
  var styleSheetsLength = styleSheets.length;
  for (var i = 0; i < styleSheetsLength; i++) {
    var classes = styleSheets[i].rules || styleSheets[i].cssRules;
    if (!classes) {
      continue;
    }
    var classesLength = classes.length;
    for (var x = 0; x < classesLength; x++) {
      if (classes[x].selectorText === className) {
        if (classes[x].style) {
          return classes[x].style;
        }
      }
    }
  }
};

var detectSwipe = function detectSwipe(el, func) {
  var swipe_det = {
    sX: 0,
    sY: 0,
    eX: 0,
    eY: 0
  };
  var min_x = 100; //min x swipe for horizontal swipe
  var max_x = 30; //max x difference for vertical swipe
  var min_y = 50; //min y swipe for vertical swipe
  var max_y = 60; //max y difference for horizontal swipe
  var direction = "";

  el.addEventListener('touchstart', function (e) {
    var t = e.touches[0];
    swipe_det.sX = t.screenX;
    swipe_det.sY = t.screenY;
  }, false);

  el.addEventListener('touchmove', function (e) {
    var t = e.touches[0];
    swipe_det.eX = t.screenX;
    swipe_det.eY = t.screenY;
  }, false);

  el.addEventListener('touchend', function (e) {
    if ((swipe_det.eX - min_x > swipe_det.sX || swipe_det.eX + min_x < swipe_det.sX) && swipe_det.eY < swipe_det.sY + max_y && swipe_det.sY > swipe_det.eY - max_y && swipe_det.eX > 0) {
      //horizontal detection
      if (swipe_det.eX > swipe_det.sX) {
        direction = "right";
      } else {
        direction = "left";
      }
    } else if ((swipe_det.eY - min_y > swipe_det.sY || swipe_det.eY + min_y < swipe_det.sY) && swipe_det.eX < swipe_det.sX + max_x && swipe_det.sX > swipe_det.eX - max_x && swipe_det.eY > 0) {
      //vertical detection
      if (swipe_det.eY > swipe_det.sY) {
        direction = "down";
      } else {
        direction = "up";
      }
    }

    if (direction !== "" && typeof func === 'function') {
      func(el, direction);
    }
  }, false);
};

var displayTime = function displayTime(time) {
  time = Math.round(time);
  var hrs = ~~(time / 3600);
  var mins = ~~(time % 3600 / 60);
  var secs = time % 60;
  if (isNaN(secs)) {
    secs = 0;
  }
  var ret = '';
  ret += '' + hrs + ':' + (mins < 10 ? '0' : '');
  ret += '' + mins + ':' + (secs < 10 ? '0' : '');
  ret += '' + secs;
  return ret;
};

var utilities = {
  install: function install(Vue, options) {
    Vue.prototype.$utilities = {
      hasClass: hasClass,
      getWidthOfClass: getWidthOfClass,
      parseStyleString: parseStyleString,
      getTransitionDurationOfClass: getTransitionDurationOfClass,
      getClassStyle: getClassStyle,
      detectSwipe: detectSwipe,
      displayTime: displayTime
    };
  },
  hasClass: hasClass,
  getWidthOfClass: getWidthOfClass,
  parseStyleString: parseStyleString,
  getTransitionDurationOfClass: getTransitionDurationOfClass,
  getClassStyle: getClassStyle,
  detectSwipe: detectSwipe,
  displayTime: displayTime
};

/* harmony default export */ __webpack_exports__["a"] = (utilities);

/***/ }),

/***/ "WH9s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WTob":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xhr__ = __webpack_require__("1Xk4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xhr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_xhr__);






var vks = {
  URLS: {
    disco: 'https://viakeyscreen.com/disco/',
    version: '/version/',
    legacy: '/migrate/uri',
    items: function items(id) {
      return '/media/' + id + '/items';
    },
    relatedMovies: function relatedMovies(id) {
      return '/media/' + id + '/related';
    },
    media: '/media/',
    schedule: '/feed/schedule/',
    feed: '/feed/all/',
    trending: '/feed/trending/',
    search: '/search/',
    babel: '/search/babel',
    video: '/xchg/video/',
    stream: '/hls/master/',
    track: '/track',
    autocomplete: '/search/autocomplete',
    related: '/search/related/',
    asset: '/asset/',
    match: '/media/match/',
    contact: '/contact',
    subscribe: '/subscribe/',
    activity: function activity(id) {
      return '/profile/' + id + '/activity/';
    },
    update: function update(id) {
      return '/profile/' + id + '/update/';
    },
    token: '/profile/token/sms',
    voucher: '/payment/voucher',
    campaign: function campaign(id, name) {
      return '/campaign/media/' + id + '/' + name;
    },
    profile: function profile(id) {
      return {
        get: function get() {
          return '/profile/' + id;
        },
        update: function update() {
          return '/profile/' + id + '/update/';
        }
      };
    }
  },
  HEADERS: {},
  VERSION:  true ? 'vks2' : 'beta'
};

vks.parseUriParams = function (params) {
  var param = '';
  var p;

  if (params) {
    param = '?';
    for (p in params) {
      if (params.hasOwnProperty(p)) {
        param += p;
        param += '=';
        if (params[p] && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(params[p]) === 'object' && params[p].constructor === Object) {
          params[p] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(params[p]);
        }
        param += params[p];
        param += '&';
      }
    }
    param = param.slice(0, -1);
  }

  return param;
};

vks.format = {
  item: function item(res) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (res.length) {
        resolve(res[0]);
      } else {
        reject(res);
      }
    });
  },

  legacy: function legacy(res) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (res.rows && res.rows.length) {
        resolve(res.rows[0]);
      } else {
        reject(res);
      }
    });
  },

  media: function media(res) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (res.rows && res.rows.length) {
        resolve(res.rows[0].doc);
      } else {
        reject(res);
      }
    });
  },

  rows: function rows(res) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      // null data removed temporarily
      if (res.rows && res.rows.length) {
        resolve(res.rows);
      } else {
        reject(res);
      }
    });
  },

  data: function data(res) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (res) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  }
};

vks.init = function (domain, outlet, version, opts) {

  vks.HEADERS['x-vks-outlet'] = outlet;
  vks.HEADERS['x-vks-language'] = 'arabic'; // TBD

  if (opts) {
    if (opts.language) {
      vks.HEADERS['x-vks-language'] = opts.language;
    }

    if (opts.debug) {
      vks.HEADERS['x-vks-debug'] = opts.debug;
    }

    if (opts.preview) {
      vks.HEADERS['x-vks-preview'] = opts.preview;
      if (opts.preview_id) {
        vks.HEADERS['x-vks-preview-id'] = opts.preview_id;
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var checkVersion;
    var getBase;
    var baseUrl =  true ? 'https://viakeyscreen.com/domain/' + domain : 'https://beta.viakeyscreen.com/domain/' + domain;

    checkVersion = function checkVersion(retry) {
      var versionOpts = void 0;
      var versionCb = void 0;

      if (!vks.URLS.base) {
        vks.URLS.base = baseUrl;
      }
      versionOpts = {
        method: 'get',
        url: vks.URLS.base + vks.URLS.version + outlet + vks.parseUriParams({ 'version': version }),
        headers: vks.HEADERS,
        json: true
      };

      versionCb = function versionCb(err, res, body) {
        if (retry && (err || res.statusCode < 200 || res.statusCode >= 300)) {
          getBase();
        } else if (err) {
          reject({ error: err });
        } else if (res.statusCode < 200 || res.statusCode >= 300) {
          reject(body);
        } else {
          resolve();
        }
      };

      __WEBPACK_IMPORTED_MODULE_4_xhr___default()(versionOpts, versionCb);
    };

    getBase = function getBase() {
      var options;
      var callback;
      options = {
        method: 'get',
        url: vks.URLS.disco + domain + vks.parseUriParams({ 'version': vks.VERSION }),
        json: true
      };

      callback = function callback(err, res, body) {
        if (err) {
          reject({ error: err });
        } else if (res.statusCode < 200 || res.statusCode >= 300) {
          reject(body);
        } else {
          vks.URLS.base = body.url;
          checkVersion();
        }
      };

      __WEBPACK_IMPORTED_MODULE_4_xhr___default()(options, callback);
    };

    checkVersion(true);
  });
};

vks.req = function (options, params, headers) {

  if (params) {
    options.url += vks.parseUriParams(params);
  }

  options.headers = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, vks.HEADERS, headers);
  options.json = true;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_4_xhr___default()(options, function (err, res, body) {
      if (err || res.statusCode < 200 || res.statusCode > 299) {
        reject(res);
      } else {
        resolve(body);
      }
    });
  });
};

vks.get = function (uri, params, headers) {
  var options = {
    method: 'GET',
    url: vks.URLS.base + uri
  };

  return vks.req(options, params, headers);
};

vks.post = function (uri, body, params, headers) {
  var options = {
    method: 'POST',
    url: vks.URLS.base + uri,
    body: body
  };

  return vks.req(options, params, headers);
};

vks.request = {
  legacy: function legacy(params) {
    return vks.get(vks.URLS.legacy, params).then(vks.format.legacy);
  },

  items: function items(id, params, headers) {
    return vks.get(vks.URLS.items(id), params, headers).then(vks.format.rows);
  },

  relatedMovies: function relatedMovies(id, params) {
    return vks.get(vks.URLS.relatedMovies(id), params).then(vks.format.rows);
  },

  media: function media(uri) {
    return vks.get(vks.URLS.media + uri).then(vks.format.media);
  },

  schedule: function schedule(placement, params) {
    return {
      current: function current() {
        return vks.get(vks.URLS.schedule + placement, params).then(vks.format.item);
      },
      feed: function feed() {
        return vks.get(vks.URLS.schedule + placement, params).then(vks.format.data);
      },
      items: function items() {
        return vks.get(vks.URLS.schedule + placement, params).then(vks.format.media);
      },
      playlists: function playlists() {
        return vks.get(vks.URLS.schedule + placement, params).then(vks.format.rows);
      }
    };
  },

  trending: function trending(placement, params) {
    return vks.get(vks.URLS.trending + placement, params).then(vks.format.rows);
  },

  feed: function feed(name, params) {
    return vks.get(vks.URLS.feed + name, params).then(vks.format.data);
  },

  search: function search(index, params) {
    return vks.get(vks.URLS.search + index, params).then(vks.format.data);
  },

  babel: function babel(query, filters) {
    var buildFilter = '';
    var items;
    var params = {
      q: query
    };

    for (items in filters) {
      if (filters.hasOwnProperty(items)) {
        buildFilter += items + ':"' + filters[items] + '" ';
      }
    }
    params.filter = buildFilter;

    return vks.get(vks.URLS.babel, params).then(vks.format.data);
  },

  video: function video(id, player, debug) {
    var headers = {};
    if (player) {
      headers['x-vks-player'] = player;
    }
    if (debug) {
      headers['x-vks-debug'] = debug;
    }

    return vks.get(vks.URLS.video + id, {}, headers).then(vks.format.data);
  },

  subtitle: function subtitle(url) {
    var options = {
      method: 'get',
      url: url
    };
    return vks.req(options);
  },

  autocomplete: function autocomplete(query, params) {
    if (!params) {
      params = {};
    }
    params.q = query;

    return vks.get(vks.URLS.autocomplete, params).then(vks.format.rows);
  },

  channel: function channel(url, params) {
    return vks.get(vks.URLS.search + url, params).then(vks.format.rows);
  },

  related: function related(url, params) {
    return vks.get(vks.URLS.related + url, params).then(vks.format.rows);
  },

  asset: function asset(url, params) {
    return vks.get(vks.URLS.asset + url, params);
  },

  match: function match(id, params) {
    return vks.get(vks.URLS.match + id, params);
  },

  contact: function contact() {
    return vks.get(vks.URLS.contact);
  },

  form: function form(params) {
    var body = {
      name: params.name,
      email: params.mail,
      text: params.msg,
      number: params.captcha
    };
    return vks.post(vks.URLS.contact + '/' + params.token, body);
  },

  subscribe: function subscribe(params) {
    var body = {
      email: params.mail,
      subscribed: params.sub
    };
    return vks.post(vks.URLS.subscribe + params.format, body);
  },

  activity: function activity(profileId, name, mediaId, params) {
    var body = {};
    return vks.post(vks.URLS.activity(profileId) + name + '/' + mediaId, body, params);
  },

  update: function update(params, profileId) {
    return vks.post(vks.URLS.update(profileId), params);
  },

  token: function token(params) {
    var body = params;
    return vks.post(vks.URLS.token, body);
  },

  voucher: function voucher(params, headers) {
    var body = params;
    return vks.post(vks.URLS.voucher, body, {}, headers);
  },

  campaign: function campaign(id, name, params) {
    return vks.get(vks.URLS.campaign(id, name), params).then(vks.format.rows);
  },

  profile_activity: function profile_activity(profileId, activityName, params) {
    return {
      get: function get(mediaId) {
        return vks.get(vks.URLS.activity(profileId) + activityName + '/' + (mediaId || ''), params).then(vks.format.data);
      },
      post: function post(mediaId) {
        return vks.post(vks.URLS.activity(profileId) + activityName + '/' + mediaId, {}, params);
      },
      update: function update(activityId) {
        return vks.post(vks.URLS.activity(profileId) + activityId, {}, params);
      }
    };
  }
};

vks.track = {
  buffering: function buffering(mediaId, renditionId, position, successCb, errorCb) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var options;
      var callback;
      var metrics;
      var dimensions;

      metrics = {
        msec: {
          n: position
        }
      };

      dimensions = {
        media_id: mediaId,
        rendition_id: renditionId,
        name: 'buffering',
        app: 'player'
      };

      options = {
        method: 'post',
        url: vks.URLS.base + vks.URLS.track,
        headers: {
          'Content-Type': 'application/json'
        },
        body: {
          metrics: metrics,
          dimensions: dimensions
        },
        json: true
      };

      callback = function callback(err, res, body) {
        if (err) {
          if (errorCb) {
            errorCb();
          }
          reject({ error: err });
        } else {
          if (successCb) {
            successCb();
          }
          resolve(body);
        }
      };

      vks.req(options, callback);
    });
  }
};

vks.getBaseUrl = function () {
  return vks.URLS.base;
};
vks.getStreamUrl = function (mediaId) {
  return vks.URLS.base + vks.URLS.stream + mediaId;
};
vks.getImageUrl = function (id, name) {
  return vks.URLS.base + vks.URLS.asset + id + name;
};

vks.setLanguage = function (lang) {
  if (vks.HEADERS['x-vks-language'] && vks.HEADERS['x-vks-language'] !== lang) {
    vks.HEADERS['x-vks-language'] = lang;
    return true;
  }
  return false;
};
vks.getLanguage = function () {
  return vks.HEADERS['x-vks-language'];
};

/* harmony default export */ __webpack_exports__["a"] = (vks);

console.log('vks-sdk', 'ready');

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home__ = __webpack_require__("wUZA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_booking__ = __webpack_require__("J0Mm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_paymentSuccessful__ = __webpack_require__("NBqp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_paymentFail__ = __webpack_require__("O6or");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_contact__ = __webpack_require__("S4JM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_privacyPolicy__ = __webpack_require__("PwwB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_returnPolicy__ = __webpack_require__("bFhG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_checkout__ = __webpack_require__("N4Va");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_confirmation__ = __webpack_require__("KeMG");














__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/:playlistId/:playlistName/booking',
    name: 'Booking',
    component: __WEBPACK_IMPORTED_MODULE_3__components_booking__["a" /* default */],
    meta: {
      showBackBtn: true,
      bgBlack: false
    }
  }, {
    path: '/contact-us',
    name: 'ContactUs',
    component: __WEBPACK_IMPORTED_MODULE_6__components_contact__["a" /* default */],
    meta: {
      showBackBtn: true,
      bgBlack: true
    }
  }, {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: __WEBPACK_IMPORTED_MODULE_7__components_privacyPolicy__["a" /* default */],
    meta: {
      showBackBtn: true,
      bgBlack: true
    }
  }, {
    path: '/refund-policy',
    name: 'RefundPolicy',
    component: __WEBPACK_IMPORTED_MODULE_8__components_returnPolicy__["a" /* default */],
    meta: {
      showBackBtn: true,
      bgBlack: true
    }
  }, {
    path: '/success',
    name: 'Success',
    component: __WEBPACK_IMPORTED_MODULE_4__components_paymentSuccessful__["a" /* default */],
    meta: {
      showBackBtn: false,
      bgBlack: false
    }
  }, {
    path: '/fail',
    name: 'Failed',
    component: __WEBPACK_IMPORTED_MODULE_5__components_paymentFail__["a" /* default */],
    meta: {
      showBackBtn: false,
      bgBlack: false
    }
  }, {
    path: '/checkout',
    name: 'Checkout',
    component: __WEBPACK_IMPORTED_MODULE_9__components_checkout__["a" /* default */],
    meta: {
      showBackBtn: true,
      bgBlack: false
    }
  }, {
    path: '/:media_id/:activity_id/confirmation',
    name: 'Confirmation',
    component: __WEBPACK_IMPORTED_MODULE_10__components_confirmation__["a" /* default */],
    meta: {
      showBackBtn: false,
      bgBlack: false
    }
  }, {
    path: '/:id?/:name?',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_home__["a" /* default */],
    meta: {
      showBackBtn: false,
      bgBlack: false
    }
  }, {
    path: '/*',
    redirect: {
      name: 'Home'
    }
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (to.name !== from.name) {
      return { x: 0, y: 0 };
    }
  }
}));

/***/ }),

/***/ "ZCRR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bb-px2pt6 border-box"},[_c('div',{staticClass:"clearfix relative"},[_c('div',{staticClass:"xl-col xl-col-6 bb-xl-max-w55 center bb-xl-left-align"},[_c('div',{staticClass:"relative bb-mt3pt56"},[_c('div',{staticClass:"absolute bb-vcr bb-bc2 bb-w0pt5 bb-h0pt5 bb-br0pt5 bb-leftn1\n        xs-hide sm-hide md-hide lg-hide"}),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1pt2 bb-fc1"},[_vm._v("\n          "+_vm._s(_vm.$lang.messages.select_experience)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"bb-min-h3pt5"},_vm._l((_vm.experiences),function(experience,i){return _c('div',{staticClass:"relative mt2 inline-block"},[_c('div',{staticClass:"inline-block relative bb-pointer",class:{'mr2': i !== _vm.experiences.length - 1, 'ml2': i !== 0},on:{"click":function($event){_vm.expSelect(experience.value._id, experience.doc.name)}}},[_c('router-link',{staticClass:"text-decoration-none",attrs:{"to":{ name: 'Booking', params: { playlistId:
            experience.value._id, playlistName: experience.doc.name}}}},[_c('div',{staticClass:"bb-ff2 bb-fs1pt29 bb-fc3 bb-transition4\n              bb-bc12-hover bb-fc1-hover bb-px0pt8 bb-h2 bb-lh2",class:{'bb-bc7 bb-fc11':
              _vm.selectedExpId === experience.value._id}},[_vm._v("\n                "+_vm._s(experience.doc.name)+"\n              ")])])],1)])})),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1pt29 bb-fc1 bb-mt2pt6"},[_vm._v("\n        "+_vm._s(_vm.$lang.messages.in_session)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"bb-h13pt5 mt2"},[(_vm.playlistData)?_c('carrousel',{attrs:{"swiperData":_vm.playlistData}}):_vm._e(),_vm._v(" "),(!_vm.playlistData)?_c('div',{staticClass:"relative bb-w15 bb-mid-w30 bb-h100p mx-auto bb-xl-mli"},[_c('img',{staticClass:"absolute bb-vhcr bb-w5 bb-h5",attrs:{"src":__webpack_require__("OTU4")}})]):_vm._e()],1),_vm._v(" "),(_vm.selectedExperience)?_c('div',{staticClass:"mt2 bb-mxw30 mx-auto bb-xl-ml0"},_vm._l((_vm.selectedExperience.doc.keywords.genre),function(genre,i){return _c('div',{staticClass:"inline-block bb-ff2 bb-fs1 mr2 bb-fc12"},[_vm._v("\n          "+_vm._s(genre)+"\n        ")])})):_vm._e(),_vm._v(" "),(_vm.selectedExperience)?_c('div',{staticClass:"mt2 pb2 bb-ff2 bb-fs1 bb-fc3 bb-mxw30 mx-auto bb-xl-ml0"},[_vm._v("\n        "+_vm._s(_vm.selectedExperience.doc.synopsis)+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"sm-col sm-col-12 xl-col-6 center bb-xl-left-align mt2 bb-xl-mt1"},[_c('div',{staticClass:"relative"},[_c('div',{staticClass:"bb-ff2 bb-fs1pt2 bb-fc1 mt2"},[_vm._v("\n          "+_vm._s(_vm.$lang.messages.select_date)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"absolute bb-vcr bb-bc2 bb-w0pt5 bb-h0pt5 bb-br0pt5 bb-leftn1 xs-hide sm-hide md-hide lg-hide"})]),_vm._v(" "),_c('div',[(_vm.datesArr.length === 0)?_c('div',{staticClass:"inline-block mx2 relative bb-h4pt5 bb-w3pt5 mt3"},[_vm._m(0)]):_c('div',[_c('div',{staticClass:"sm-hide md-hide lg-hide xl-hide flex bb-jcc bb-aic mt3"},[_c('div',{staticClass:"inline-block bb-lg-mln2pt5",class:{ 'bb-op0': _vm.datesSliderStart, 'bb-pointer': !_vm.datesSliderStart},on:{"click":_vm.datesSlidePrev}},[_c('i',{staticClass:"material-icons bb-fs2pt17 bb-fc1 bb-usnone"},[_vm._v("")])]),_vm._v(" "),_c('div',{staticClass:"inline-block center bb-w80p bb-max-w40"},[_c('swiper',{ref:"dates",attrs:{"options":_vm.datesSwiperOption}},_vm._l((_vm.datesArr),function(day,index){return _c('swiper-slide',{key:index},[_c('div',{staticClass:"inline-block mx2 relative bb-h4pt5 bb-w3pt5"},[_c('div',{staticClass:"relative bb-vhcr bb-hover-trigger2 bb-pointer",class:[ _vm.dateFullyBooked(_vm.campData[day.toDate()].showTimes) ?
                      'bb-default' : 'bb-pointer' ],on:{"click":function($event){_vm.dateSelect(day, index)}}},[_c('div',{staticClass:"bb-ff3 bb-fs1pt29 bb-fc1 bb-transition4 center",class:{ 'bb-fc11': _vm.selectedDateIndex === index,
                      'bb-fc10': _vm.dateFullyBooked(_vm.campData[day.toDate()].showTimes) }},[_vm._v("\n                      "+_vm._s(_vm.days[day.day()])+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"bb-ff2 center bb-fs1pt29 bb-fc1 bb-transition4\n                      bb-fc9-hover mx-auto mt1 bb-w2pt5 bb-h2pt5 bb-lh2pt5",class:[ _vm.selectedDateIndex === index ? 'bb-fc11 bb-bc7' : '',
                      _vm.dateFullyBooked(_vm.campData[day.toDate()].showTimes) ? 'bb-fc10' : 'bb-bc12-hover' ]},[_vm._v("\n                      "+_vm._s(day.date())+"\n                      ")])])])])}))],1),_vm._v(" "),_c('div',{staticClass:"inline-block ml1",class:[ _vm.datesSliderEnd ? 'bb-op0pt3' : '',
          _vm.datesSliderSlides <= 1 ? 'bb-op0' : 'bb-pointer'],on:{"click":_vm.datesSlideNext}},[_c('i',{staticClass:"material-icons bb-fs2pt17 bb-fc1 bb-usnone"},[_vm._v("")])])]),_vm._v(" "),_vm._l((_vm.datesArr),function(day,index){return _c('div',{staticClass:"inline-block mx2 relative bb-h4pt5 bb-w3pt5 mt3 xs-hide"},[_c('div',{staticClass:"relative bb-vhcr bb-hover-trigger2",class:[ _vm.dateFullyBooked(_vm.campData[day.toDate()].showTimes) ? 'bb-default' : 'bb-pointer' ],on:{"click":function($event){_vm.dateSelect(day, index)}}},[_c('div',{staticClass:"bb-ff3 bb-fs1pt29 bb-fc1 bb-transition4 center",class:{ 'bb-fc11': _vm.selectedDateIndex === index,
                'bb-fc10': _vm.dateFullyBooked(_vm.campData[day.toDate()].showTimes) }},[_vm._v("\n                "+_vm._s(_vm.days[day.day()])+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"bb-ff2 center bb-fs1pt29 bb-fc1 bb-transition4\n                bb-fc9-hover mx-auto mt1 bb-w2pt5 bb-h2pt5 bb-lh2pt5",class:[ _vm.selectedDateIndex === index ? 'bb-fc11 bb-bc7' : '',
                _vm.dateFullyBooked(_vm.campData[day.toDate()].showTimes) ? 'bb-fc10' : 'bb-bc12-hover' ]},[_vm._v("\n                "+_vm._s(day.date())+"\n              ")])])])})],2)]),_vm._v(" "),_c('div',{staticClass:"relative"},[_c('div',{staticClass:"bb-mt2pt6 bb-ff2 bb-fs1pt2 bb-fc1"},[_vm._v("\n          "+_vm._s(_vm.$lang.messages.select_session)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"absolute bb-vcr bb-bc2 bb-w0pt5 bb-h0pt5 bb-br0pt5 bb-leftn1 xs-hide sm-hide md-hide lg-hide"})]),_vm._v(" "),(_vm.timesPlaceholder.length < 6)?_c('div',{staticClass:"clearfix"},[(_vm.timesPlaceholder.length === 0)?_c('div',{staticClass:"bb-mt1pt3 mx-auto flex bb-jcc bb-aic bb-xl-jcl"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"inline-block center bb-w80p bb-max-w40"},[_c('swiper',[_c('swiper-slide',[_c('div',{staticClass:"inline-block relative px1"},[_c('div',{staticClass:"bb-ff2 bb-fs1pt29 bb-transition4\n              bb-px0pt8 bb-h2 bb-lh2 bb-fc13"},[_vm._v("\n                    0am\n                  ")])])])],1)],1),_vm._v(" "),_vm._m(2)]):_vm._l((_vm.timesPlaceholder),function(showTime,i){return _c('div',{staticClass:"relative bb-mt1pt7 inline-block px1"},[_c('div',{staticClass:"inline-block relative",on:{"click":function($event){_vm.timeSelect(showTime)}}},[_c('div',{staticClass:"bb-ff2 bb-fs1pt29 bb-transition4\n            bb-px0pt8 bb-h2pt5 bb-lh2pt5 bb-h2 bb-lh2",class:[
            _vm.searchTimePlaceholder(showTime) ? 'bb-fc3 bb-bc12-hover bb-fc1-hover bb-pointer' : 'bb-fc10 bb-default', showTime
            === _vm.selectedTime ? 'bb-bc7 bb-fc11' : '']},[_vm._v("\n            "+_vm._s(_vm._f("formatHours")(showTime))+"\n            ")])])])})],2):_c('div',{staticClass:"bb-mt1pt3 mx-auto flex bb-jcc bb-aic bb-xl-jcl"},[_c('div',{staticClass:"inline-block mt1 bb-lg-mln2pt5",class:{ 'bb-op0': _vm.sessionSliderStart, 'bb-pointer': !_vm.sessionSliderStart},on:{"click":_vm.sessionSlidePrev}},[_c('i',{staticClass:"material-icons bb-fs2pt17 bb-fc1 bb-usnone"},[_vm._v("")])]),_vm._v(" "),_c('div',{staticClass:"inline-block center bb-w80p bb-max-w40"},[_c('swiper',{ref:"sessions",attrs:{"options":_vm.sessionSwiperOption}},_vm._l((_vm.timesPlaceholder),function(showTime,i){return _c('swiper-slide',{key:showTime},[_c('div',{staticClass:"inline-block relative px1"},[_c('div',{staticClass:"bb-ff2 bb-fs1pt29 bb-transition4\n            bb-px0pt8 bb-h2pt5 bb-lh2pt5 bb-h2 bb-lh2",class:[_vm.searchTimePlaceholder(showTime) ? 'bb-fc3 bb-bc12-hover bb-fc1-hover bb-pointer' : 'bb-fc10 bb-default', 
                  showTime === _vm.selectedTime ? 'bb-bc7 bb-fc11' : ''],on:{"click":function($event){_vm.timeSelect(showTime)}}},[_vm._v("\n                  "+_vm._s(_vm._f("formatHours")(showTime))+"\n                ")])])])}))],1),_vm._v(" "),_c('div',{staticClass:"inline-block ml1 mt1",class:[ _vm.sessionSliderEnd ? 'bb-op0pt3' : '',
          _vm.sessionSliderSlides <= 1 ? 'bb-op0' : 'bb-pointer'],on:{"click":_vm.sessionSlideNext}},[_c('i',{staticClass:"material-icons bb-fs2pt17 bb-fc1 bb-usnone"},[_vm._v("")])])]),_vm._v(" "),_c('div',{staticClass:"relative"},[_c('div',{staticClass:"bb-mt2pt6 bb-ff2 bb-fs1pt2 bb-fc1"},[_vm._v("\n          "+_vm._s(_vm.$lang.messages.select_places)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"absolute bb-vcr bb-bc2 bb-w0pt5 bb-h0pt5 bb-br0pt5 bb-leftn1 xs-hide sm-hide md-hide lg-hide"})]),_vm._v(" "),(_vm.seatsPlaceholder === 0)?_c('div',[_vm._m(3)]):(_vm.seatsPlaceholder < 3)?_c('div',_vm._l((_vm.seatsPlaceholder),function(n){return _c('div',{staticClass:"inline-block relative px2 bb-mt1pt7"},[_c('div',{staticClass:"bb-fs1pt29 bb-ff2 bb-transition4 bb-w2pt5 bb-h2pt5\n          bb-lh2pt5 center",class:[_vm.selectedOptions.selectedPlaces === n ? 'bb-fc11 bb-bc7' : '',
          _vm.searchPlacesPlaceholder(n) ? 'bb-fc3 bb-bc12-hover bb-fc1-hover bb-pointer'
          : 'bb-fc10 bb-default'],on:{"click":function($event){_vm.selectPlaces(n)}}},[_vm._v("\n            "+_vm._s((n / 10 < 1 ? '0' : '') + n)+"\n          ")])])})):_c('div',{staticClass:"bb-mt1pt3 mx-auto flex bb-jcc bb-aic bb-xl-jcl"},[_c('div',{staticClass:"inline-block mt1 bb-lg-mln2pt5",class:{ 'bb-op0': _vm.placesSliderStart, 'bb-pointer': !_vm.placesSliderStart},on:{"click":_vm.placesSlidePrev}},[_c('i',{staticClass:"material-icons bb-fs2pt17 bb-fc1 bb-usnone"},[_vm._v("")])]),_vm._v(" "),_c('div',{staticClass:"inline-block center bb-w80p bb-max-w40"},[_c('swiper',{ref:"places",attrs:{"options":_vm.placesSwiperOption}},_vm._l((_vm.seatsPlaceholder),function(n){return _c('swiper-slide',{key:n},[_c('div',{staticClass:"inline-block relative"},[_c('div',{staticClass:"bb-fs1pt29 bb-ff2 bb-transition4 bb-w2pt5 bb-h2pt5\n                bb-lh2pt5",class:[_vm.selectedOptions.selectedPlaces === n ? 'bb-fc11 bb-bc7' : '',
                  _vm.searchPlacesPlaceholder(n) ? 'bb-fc3 bb-bc12-hover bb-fc1-hover bb-pointer'
                  : 'bb-fc10 bb-default'],on:{"click":function($event){_vm.selectPlaces(n)}}},[_vm._v("\n                  "+_vm._s((n / 10 < 1 ? '0' : '') + n)+"\n                ")])])])}))],1),_vm._v(" "),_c('div',{staticClass:"inline-block ml1 mt1",class:[ _vm.placesSliderEnd ? 'bb-op0pt3' : '',
          _vm.placesSliderSlides <= 1 ? 'bb-op0' : 'bb-pointer'],on:{"click":_vm.placesSlideNext}},[_c('i',{staticClass:"material-icons bb-fs2pt17 bb-fc1 bb-usnone"},[_vm._v("")])])]),_vm._v(" "),_c('div',{staticClass:"bb-mt2pt6 bb-w100p bb-h0pt1 bb-bc8 mt2 bb-bc13 bb-mxw31pt3 mx-auto bb-xl-ml0"}),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"xl-col bb-ff2 bb-fs1pt2 bb-fc4 bb-mt2pt6 bb-xl-mt2"},[_vm._v("\n          "+_vm._s(_vm.$lang.messages.your_booking)+"\n        ")]),_vm._v(" "),(_vm.selectedUTCDate !== null && _vm.selectedTime !== null && _vm.selectedOptions.selectedPlaces !== 0)?_c('div',{staticClass:"xl-col xl-col-8 bb-ff2 bb-fs1pt29 bb-fc3 mt2 bb-xl-mt2\n          bb-xl-pl2 border-box"},[_vm._v("\n          "+_vm._s(_vm.fullDays[_vm.selectedUTCDate.getDay()])+"\n          "+_vm._s(_vm.selectedUTCDate.getDate())+" @ "+_vm._s(_vm._f("formatHours")(_vm.selectedTime))+"\n          #"+_vm._s((_vm.selectedOptions.selectedPlaces / 10 < 1 ? '0' : '') + _vm.selectedOptions.selectedPlaces)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.selectedUTCDate === null || _vm.selectedTime === null
          || _vm.selectedOptions.selectedPlaces === 0)?_c('div',{staticClass:"xl-col xl-col-8 bb-ff2 bb-fs1pt29 bb-fc3 mt2 bb-xl-mt2 bb-xl-pl2 border-box"},[_vm._v("\n          "+_vm._s(_vm.allDatesFullyBooked() ? '' : _vm.$lang.messages.select_phrase)+"\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"xl-col bb-ff2 bb-fs1pt2 bb-fc4 mt2"},[_vm._v("\n          "+_vm._s(_vm.$lang.messages.total_payment)+"\n        ")]),_vm._v(" "),(_vm.selectedTime !== null && _vm.selectedOptions.selectedPlaces !== 0)?_c('div',{staticClass:"xl-col xl-col-3 bb-ff2 bb-fs1pt29 bb-fc3 mt2 bb-xl-pl2"},[_vm._v("\n          $"+_vm._s(_vm.selectedOptions.selectedPlaces * this.selectedOptions.sessionData.price)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.selectedTime === null || _vm.selectedOptions.selectedPlaces === 0)?_c('div',{staticClass:"xl-col xl-col-3 bb-ff2 bb-fs1pt29 bb-fc3 mt2 bb-xl-pl2"},[_vm._v("\n          $0\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"bb-mt2pt6 bb-w100p bb-h0pt1 bb-bc8 mt2 bb-bc13 bb-mxw31pt3\n      mx-auto bb-xl-ml0"}),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"mt2 bb-mxw31pt3 mx-auto bb-xl-ml0 bb-w100p"},[_c('div',{staticClass:"center mx-auto border-box bb-pointer bb-bc2-hover bb-bc2 bb-sm-bc-transp\n            bb-ff3 bb-fs1 bb-fc1 bb-sm-fc2 bb-fc1-hover bb-brd3 bb-h2pt5 bb-py1pt25 bb-lh0\n            bb-transition2",on:{"click":_vm.checkOut}},[_vm._v("\n            "+_vm._s(_vm.$lang.messages.check_out)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1pt29 bb-fc3 mt2"},[_c('div',{staticClass:"inline-block"},[_vm._v(_vm._s(_vm.verificationPh))]),_vm._v(" "),_c('div',{staticClass:"inline-block bb-fc2"},[_vm._v(_vm._s(_vm.username))])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative bb-vhcr"},[_c('div',{staticClass:"bb-ff3 bb-fs1pt29 bb-fc13 center"},[_vm._v("\n            Day\n            ")]),_vm._v(" "),_c('div',{staticClass:"bb-ff2 center bb-fs1pt29 bb-fc13 mx-auto mt1 bb-w2pt5 bb-h2pt5 bb-lh2pt5"},[_vm._v("\n            0\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-block mt1 bb-lg-mln2pt5 bb-op0"},[_c('i',{staticClass:"material-icons bb-fs2pt17 bb-fc1 bb-usnone"},[_vm._v("")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-block bb-pointer ml1 mt1 bb-op0"},[_c('i',{staticClass:"material-icons bb-fs2pt17 bb-fc1 bb-usnone"},[_vm._v("")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-block relative px2 bb-mt1pt7"},[_c('div',{staticClass:"bb-fs1pt29 bb-ff2 bb-transition4 bb-w2pt5 bb-h2pt5\n          bb-lh2pt5 center bb-fc13"},[_vm._v("\n          00\n          ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZdBu":
/***/ (function(module, exports) {

module.exports = {
  book_session: 'Book Your Session',
  now_showing: 'Now showing',
  booking: 'Booking',
  details: 'ABOUT',
  logout: 'Logout',
  pick: 'Once you are there you can pick whatever you like to see',
  in_session: 'Top Picks:',
  select_experience: 'SELECT YOUR VR EXPERIENCE',
  select_date: 'SELECT YOUR SESSION DATE',
  select_session: 'SELECT YOUR SESSION TIME',
  select_places: 'BOOK YOUR NUMBER OF SEAT ',
  your_booking: 'YOUR BOOKING',
  select_phrase: 'Please Select Date, Time and Number Of Seats',
  total_payment: 'TOTAL',
  check_out: 'Check Out',
  fill_require: '*Fill in the required info in order to check out',
  request_code: 'Request Code',
  user_logout: 'Logout',
  cancel: 'Cancel',
  logout_verification: 'Are your sure you want to logout',
  verify_account: 'VERIFY YOUR ACCOUNT',
  voucher_code: 'voucher code*',
  payment_sbtitle: 'Please fill in your credentials to create an account with us',
  p1: 'First name*',
  p2: 'Phone Number*',
  p3: 'Email*',
  p4: '* 4 digits code',
  p5: '* Enter voucher code',
  p6: 'Email address*',
  p7: 'Last name*',
  select_confirm: '*By click Book Session you will get all 4 PACKS',
  address: 'ADDRESS',
  address_loc_p1: 'Auguste Pacha Adib - Sirian street, lot 1687',
  address_loc_p2: 'Ashrafieh - Beirut',
  email: 'EMAIL',
  email_add: 'Hello@bbangstudios.com',
  phone: 'PHONE',
  phone_num: '+961 76 083 973',
  subscribe: 'SUBSCRIBE',
  sub_succ: 'You have successfully subscribed to the bigbang newsletter.',
  send: 'Send',
  subscribe_sbtitle: 'Subscribe and be the first to receive our most recent announcements',
  err1: 'Please Select Date, Time and Number Of Seats',
  err2: 'Please Fill In A Valid Email',
  err3: 'Please Fill In The Form',
  err4: 'Please Enter A Valid Code',
  err5: 'Please Enter A Valid Phone Number',
  err6: 'This option is not available, please select a different option',
  err7: 'Sorry, Interactive experience is fully-booked, Please try again another day.',
  err8: 'Sorry, Theatre experience is fully-booked, Please try again another day.',
  refund_pol: 'REFUND POLICY FOR BIG BANG SERVICES',
  home_page: 'Home Page',
  pay_app: 'Sorry, Your payment was unsuccessful. No charges were made.',
  pay_suc: 'You have completed your online booking and payment successfully. We’ll send you a confirmation shortly.',
  retry: 'Retry',
  user_continue: 'Continue',
  verification_ph: '*Create your account here in order to checkout.',
  checkout_ph: '*Checkout as ',
  payment_process: 'PAYMENT PROCESS',
  loading: 'LOADING',
  loading_submsg1: 'Your booking is at its final stages, please wait!',
  sorry: 'WE’RE SORRY!',
  conf_err_submsg1: 'We were unable to confirm your booking.',
  conf_err_submsg2: 'We promise to give you a call soon and fix this issue, please refrain from booking again until then.',
  conf_err_submsg3: 'You can call us on +961 76 083 973 so we can help you fix this issue immediately.',
  success: 'SUCCESS',
  success_submsg1: 'Your online booking with us was successful. You submitted a booking for:',
  success_submsg2: 'You will receive a confirmation email to the address below:',
  success_submsg3: 'The reference number is:',
  token_noti: 'Please insert the verification code that was sent to your mobile device',
  payment_method_title: 'SELECT PAYMENT METHOD',
  payment_method1: 'Bigbang payments go through Payfort',
  pay_method1: 'PAY WITH CARD',
  payment_method2: 'Unless you have a voucher, then please enter the code below',
  pay_method2: 'PAY WITH VOUCHER',
  thank_you: 'THANK YOU!',
  done: 'DONE'
};

/***/ }),

/***/ "acFv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'confirm',
  data: function data() {
    return {
      paymentError: false,
      loading: true,
      voucherPayment: false,
      gatewayPaymentSuccess: false,
      paymentStatusRetry: {
        limit: 20,
        count: 0
      }
    };
  },

  computed: {
    voucherFeedback: function voucherFeedback() {
      return this.$store.getters.getVoucherActivity;
    },
    selectedOptions: function selectedOptions() {
      return this.$store.getters.getSelectedOptions;
    },
    voucherError: function voucherError() {
      return this.$store.getters.getVoucherError;
    },
    userInfo: function userInfo() {
      return this.$store.getters.getUserInfo;
    },
    bookingActivity: function bookingActivity() {
      return this.$store.getters.getBookingActivity;
    }
  },
  filters: {
    referenceId: function referenceId(id) {
      return id.substring(id.length - 8, id.length);
    }
  },
  watch: {
    voucherError: function voucherError() {
      this.loading = false;
      this.paymentError = true;
    },
    userInfo: function userInfo() {
      this.getBookingActivity();
    },

    bookingActivity: function bookingActivity() {
      var _this = this;

      //check if booked successfully
      if (this.bookingActivity && this.bookingActivity[0] && this.bookingActivity[0].doc && this.bookingActivity[0].doc.booking && this.bookingActivity[0].doc.booking.confirmed) {
        this.gatewayPaymentSuccess = true;
        this.loading = false;
      } else {
        //if not booked successfully then retry until retry limit reached
        if (this.paymentStatusRetry.count < this.paymentStatusRetry.limit - 1) {
          if (this.userLoggedIn) {
            // increase the count only if user is logged in and we are currently
            // waiting for confirmation, otherwise keep on retrying until user
            // is actually logged in.
            this.paymentStatusRetry.count = this.paymentStatusRetry.count + 1;
          }
          setTimeout(function () {
            _this.getBookingActivity();
          }, 3000);
        } else {
          // if retry limit reached, show error message
          this.loading = false;
          this.paymentError = true;
        }
      }
    }
  },
  methods: {
    getBookingActivity: function getBookingActivity() {
      this.$store.dispatch('LOAD_BOOKING_ACTIVITY', {
        id: this.$route.params.activity_id,
        token: this.$localStorage.get('token')
      });
    }
  },
  created: function created() {
    if (this.userLoggedIn) {
      if (this.voucherFeedback) {
        this.voucherPayment = true;
        this.loading = false;
      } else {
        this.getBookingActivity();
      }
    } else {
      this.forceLogin();
    }
  }
});

/***/ }),

/***/ "ajUp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "apj+":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en/messages.js": "ZdBu"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "apj+";

/***/ }),

/***/ "bBBi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Contact',
  data: function data() {
    return {
      mailPlaceholder: this.$lang.messages.p6,
      mailInput: '',
      loadingMail: false,
      inputMailActive: false,
      invalidMail: false,
      largeMap: false,
      closeBtnHighlighted: false,
      cancelTransitionClass: 'bb-transition2'
    };
  },

  methods: {
    blurMailPlaceholder: function blurMailPlaceholder(event) {
      if (event.target.value.length <= 0) {
        this.inputMailActive = false;
      }
    },
    inputMailClicked: function inputMailClicked() {
      this.inputMailActive = true;
    },
    resetValidation: function resetValidation() {
      console.log(123);
      if (this.invalidMail) {
        this.invalidMail = false;
      }
    },
    subscribeBtnClicked: function subscribeBtnClicked() {
      this.loadingMail = true;
      this.$store.dispatch('SUBSCRIBE', {
        format: 'newsletter',
        mail: this.mailInput,
        sub: true
      });
    },
    subscribeUpdated: function subscribeUpdated() {
      this.loadingMail = false;
      if (this.subscribe.subscribed) {
        this.$store.commit('SET_DISPLAY_NOTIFICATION', { show: true,
          msg: this.$lang.messages.sub_succ, state: true });
      } else {
        this.invalidMail = true;
        this.$store.commit('SET_DISPLAY_NOTIFICATION', { show: true,
          msg: this.$lang.messages.err2, state: false });
      }
    },
    showMap: function showMap(value) {
      this.largeMap = value;
    },
    highlightCloseBtn: function highlightCloseBtn() {
      this.closeBtnHighlighted = true;
      var self = this;
      setTimeout(function () {
        self.closeBtnHighlighted = false;
      }, this.$utilities.getTransitionDurationOfClass('.' + this.cancelTransitionClass) * 1000);
    }
  },
  computed: {
    subscribe: function subscribe() {
      return this.$store.getters.getSubscribe;
    }
  },
  watch: {
    'subscribe': 'subscribeUpdated'
  },
  destroyed: function destroyed() {
    this.$store.commit('SET_SUBSCRIBE', null);
  }
});

/***/ }),

/***/ "bFhG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_returnPolicy_vue__ = __webpack_require__("1N7e");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2383d406_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_returnPolicy_vue__ = __webpack_require__("lOSF");
function injectStyle (ssrContext) {
  __webpack_require__("SqJj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2383d406"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_returnPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2383d406_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_returnPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ce18":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Footer',
  data: function data() {
    return {
      socialMediaData: [{
        'url': 'https://facebook.com/BbangStudios/',
        'imgUrl': '/icons/facebook.svg',
        'imgUrlHovered': '/icons/facebook_pink.svg',
        'widthClass': 'bb-w0pt7'
      }, {
        'url': 'https://www.instagram.com/bbangstudios/',
        'imgUrl': '/icons/instagram.svg',
        'imgUrlHovered': '/icons/instagram_pink.svg',
        'widthClass': 'bb-w1pt25'
      }]
    };
  },

  methods: {
    imagePath: function imagePath(imgPath) {
      return __webpack_require__("ycmV")("./assets" + imgPath);
    }
  }
});

/***/ }),

/***/ "dNEa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dYG7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bigbang-logo01.f1e62f8.svg";

/***/ }),

/***/ "f55A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_swiper__ = __webpack_require__("+mQk");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var dayjs = __webpack_require__("oqQY");
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Booking',
  components: {
    'carrousel': __WEBPACK_IMPORTED_MODULE_1__components_swiper__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      places: 12,
      days: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      fullDays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      timesPlaceholder: [],
      seatsPlaceholder: 0,
      selectedOptions: {
        timestamp: '',
        selectedPlaces: 0,
        sessionData: null,
        experienceId: null,
        experienceName: null
      },
      selectedExpId: '',
      selectedUTCDate: null,
      selectedTime: null,
      selectedDateIndex: null,
      placesSliderStart: true,
      placesSliderEnd: false,
      placesSliderSlides: 2,
      placesSwiperOption: {
        slidesPerView: 8,
        spaceBetween: 0,
        simulateTouch: false,
        onReachBeginning: function onReachBeginning(swiper) {
          self.placesSliderStart = true;
        },
        onReachEnd: function onReachEnd(swiper) {
          if (swiper.snapGrid.length > 1) {
            self.placesSliderEnd = true;
          } else {
            self.placesSliderSlides = swiper.snapGrid.length;
          }
        },
        breakpoints: {
          1167: {
            slidesPerView: 5,
            spaceBetween: 0
          },
          736: {
            slidesPerView: 3,
            spaceBetween: 0
          }
        }
      },
      sessionSliderStart: true,
      sessionSliderEnd: false,
      sessionSliderSlides: 2,
      sessionSwiperOption: {
        slidesPerView: 6,
        spaceBetween: 0,
        simulateTouch: false,
        onReachBeginning: function onReachBeginning(swiper) {
          self.sessionSliderStart = true;
        },
        onReachEnd: function onReachEnd(swiper) {
          self.sessionSliderEnd = true;
          if (swiper.snapGrid.length > 1) {
            self.sessionSliderEnd = true;
          } else {
            self.sessionSliderSlider = swiper.snapGrid.length;
          }
        },
        breakpoints: {
          736: {
            slidesPerView: 3,
            spaceBetween: 0
          }
        }
      },
      datesSliderStart: true,
      datesSliderEnd: false,
      datesSliderSlides: 2,
      datesSwiperOption: {
        slidesPerView: 3,
        spaceBetween: 0,
        simulateTouch: false,
        onReachBeginning: function onReachBeginning(swiper) {
          self.datesSliderStart = true;
        },
        onReachEnd: function onReachEnd(swiper) {
          if (swiper.snapGrid.length > 1) {
            self.datesSliderEnd = true;
          } else {
            self.datesSliderSlides = swiper.snapGrid.length;
          }
        }
      },
      verificationPh: self.$lang.messages.verification_ph,
      username: '',
      datesArr: [],
      sessionArr: [],
      campData: {},
      campBeginDay: dayjs(),
      campEndDay: dayjs().add(6, 'day')
    };
  },

  computed: {
    placesSwiper: function placesSwiper() {
      return this.$refs.places.swiper;
    },
    sessionSwiper: function sessionSwiper() {
      return this.$refs.sessions.swiper;
    },
    datesSwiper: function datesSwiper() {
      return this.$refs.dates.swiper;
    },
    playlistData: function playlistData() {
      return this.$store.getters.getItems;
    },
    experiences: function experiences() {
      return this.$store.getters.getHomeData;
    },
    selectedExperience: function selectedExperience() {
      var _this = this;

      if (this.experiences) {
        return this.experiences.find(function (item) {
          return item.doc._id === _this.selectedExpId;
        });
      }
    },
    seatsCampaign: function seatsCampaign() {
      return this.$store.getters.getSeatCampaign;
    },
    userLoggedOut: function userLoggedOut() {
      return this.$store.getters.getLoggedIn;
    }
  },
  watch: {
    userLoggedOut: function userLoggedOut() {
      if (!this.$store.getters.getLoggedIn) {
        this.verificationPh = this.$lang.messages.verification_ph;
        this.username = '';
      } else {
        if (this.$store.getters.getVoucherToken) {
          this.verificationPh = this.$lang.messages.checkout_ph;
          this.username = this.$store.getters.getVoucherToken.username;
        }
      }
    },
    seatsCampaign: function seatsCampaign() {
      var initial = dayjs(this.seatsCampaign[0].value.time);
      this.datesArr[0] = initial;
      var tempShow = {};
      for (var i in this.seatsCampaign) {
        if (initial.day() !== dayjs(this.seatsCampaign[i].value.time).day()) {
          this.datesArr.push(dayjs(this.seatsCampaign[i].value.time));
          initial = dayjs(this.seatsCampaign[i].value.time);
          tempShow = {};
        }
        this.createCampaignData(tempShow, this.seatsCampaign[i]);
        //reserve placeholders with max number of session times
        if (this.timesPlaceholder.indexOf(dayjs(this.seatsCampaign[i].value.time).hour()) === -1) {
          this.timesPlaceholder.push(dayjs(this.seatsCampaign[i].value.time).hour());
        }
        //reserve placeholders with max number of seats
        if (this.seatsPlaceholder < this.seatsCampaign[i].value.seats.max) {
          this.seatsPlaceholder = this.seatsCampaign[i].value.seats.max;
        }
        //main object that holds #of seats price campaignId and session time
        this.campData[initial.toDate()] = { showTimes: tempShow };
      }

      // add missing days from schedule (unavailable days)
      var day = this.campBeginDay;
      // looping from campaign start day to end day
      while (!day.isAfter(this.campEndDay)) {
        var sameDay = false;
        //check if day already exists in schedule
        for (var i in this.datesArr) {
          if (day.date() === this.datesArr[i].date() && day.month() === this.datesArr[i].month()) {
            sameDay = true;
            break;
          }
        }

        // if day doesnt exist in schedule then add it
        if (!sameDay) {
          // find the index where day should be added
          for (var i in this.datesArr) {
            var temp = this.datesArr[i];
            if (day.date() > this.datesArr[0].date()) {
              if (temp.add(1, 'day').date() === day.date()) {
                this.datesArr.splice(parseInt(i) + 1, 0, day);
              }
            }

            if (day.date() < this.datesArr[0].date()) {
              this.datesArr.splice(0, 0, day);
            }
          }

          // add empty seats
          var temp = {};
          for (var key in tempShow) {
            temp[key] = {};
            for (var keyTwo in tempShow[key]) {
              temp[key][keyTwo] = 0;
            }
          }
          this.campData[day.toDate()] = { showTimes: temp };
        }

        day = day.add(1, 'day');
      }

      // sorting the times placeholders 
      this.timesPlaceholder.sort(function (a, b) {
        return a - b;
      });
    },
    selectedTime: function selectedTime() {
      this.selectedOptions.selectedPlaces = 0;
    },
    'selectedOptions.selectedPlaces': function selectedOptionsSelectedPlaces() {
      this.selectedOptions.timestamp = this.fullDays[this.selectedUTCDate.getDay()] + ' ' + this.selectedUTCDate.getDate() + ' @ ' + this.$options.filters.formatHours(this.selectedTime) + ' #' + (this.selectedOptions.selectedPlaces / 10 < 1 ? '0' : '') + this.selectedOptions.selectedPlaces;
    }
  },
  methods: {
    placesSlidePrev: function placesSlidePrev() {
      this.placesSwiper.slidePrev(true, 500);
      this.placesSliderEnd = false;
    },
    placesSlideNext: function placesSlideNext() {
      this.placesSwiper.slideNext(true, 500);
      this.placesSliderStart = false;
    },
    sessionSlidePrev: function sessionSlidePrev() {
      this.sessionSwiper.slidePrev(true, 500);
      this.sessionSliderEnd = false;
    },
    sessionSlideNext: function sessionSlideNext() {
      this.sessionSwiper.slideNext(true, 500);
      this.sessionSliderStart = false;
    },
    datesSlidePrev: function datesSlidePrev() {
      this.datesSwiper.slidePrev(true, 500);
      this.datesSliderEnd = false;
    },
    datesSlideNext: function datesSlideNext() {
      this.datesSwiper.slideNext(true, 500);
      this.datesSliderStart = false;
    },
    selectPlaces: function selectPlaces(places) {
      if (!this.allDatesFullyBooked()) {
        if (this.selectedUTCDate) {
          if (places <= this.campData[this.selectedUTCDate].showTimes[this.selectedTime].seats) {
            this.selectedOptions.selectedPlaces = places;
          } else {
            this.$store.commit('SET_DISPLAY_NOTIFICATION', { show: true,
              msg: this.$lang.messages.err6, state: false });
          }
        } else {
          this.$store.commit('SET_DISPLAY_NOTIFICATION', { show: true,
            msg: this.$lang.messages.err6, state: false });
        }
      } else {
        this.showAllDatesFullyBookedMsg();
      }
    },
    getImageUrl: function getImageUrl(uri, name) {
      return this.$store.getters.getImageUrl(uri, name);
    },
    dateSelect: function dateSelect(day, index) {
      if (!this.dateFullyBooked(this.campData[day.toDate()].showTimes)) {
        this.selectedUTCDate = day.toDate();
        this.selectedDateIndex = index;
        for (var i in this.campData[this.selectedUTCDate].showTimes) {
          if (this.campData[this.selectedUTCDate].showTimes[i].seats > 0) {
            this.selectedTime = parseInt(i);
            this.selectedOptions.sessionData = this.campData[this.selectedUTCDate].showTimes[i];
            break;
          }

          // if there are no seats, remove selections
          this.selectedTime = null;
        }
      } else if (!this.allDatesFullyBooked()) {
        this.$store.commit('SET_DISPLAY_NOTIFICATION', {
          show: true,
          msg: this.$lang.messages.err6,
          state: false });
      } else {
        this.showAllDatesFullyBookedMsg();
      }
    },
    timeSelect: function timeSelect(time) {
      if (!this.allDatesFullyBooked()) {
        if (this.searchTimePlaceholder(time)) {
          this.selectedTime = time;
          this.selectedOptions.sessionData = this.campData[this.selectedUTCDate].showTimes[time];
        } else {
          this.$store.commit('SET_DISPLAY_NOTIFICATION', { show: true,
            msg: this.$lang.messages.err6, state: false });
        }
      } else {
        this.showAllDatesFullyBookedMsg();
      }
    },
    expSelect: function expSelect(id, name) {
      this.$store.commit('SET_ITEMS', null);
      this.selectedExpId = id;
      this.selectedOptions.experienceName = name;
      this.$store.dispatch('LOAD_ITEMS', id);
    },
    checkOut: function checkOut() {
      if (this.allDatesFullyBooked()) {
        this.showAllDatesFullyBookedMsg();
      } else {
        if (this.selectedOptions.selectedPlaces === 0 || !this.selectedUTCDate || this.selectedTime === null) {
          this.$store.commit('SET_DISPLAY_NOTIFICATION', { show: true, msg: this.$lang.messages.err1, state: false });
        } else {
          this.$store.commit('SET_SELECTED_OPTIONS', this.selectedOptions);
          this.$router.push({ name: 'Checkout' });
        }
      }
    },
    searchTimePlaceholder: function searchTimePlaceholder(value) {
      if (this.selectedUTCDate) {
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.campData[this.selectedUTCDate].showTimes).indexOf(value.toString()) >= 0) {
          if (this.campData[this.selectedUTCDate].showTimes[value].seats > 0) {
            return true;
          }
        }
      }
    },
    searchPlacesPlaceholder: function searchPlacesPlaceholder(value) {
      if (this.selectedUTCDate && this.selectedTime !== null) {
        if (value <= this.campData[this.selectedUTCDate].showTimes[this.selectedTime].seats) {
          return true;
        }
      }
    },
    createCampaignData: function createCampaignData(campObj, data) {
      campObj[dayjs(data.value.time).hour()] = { seats: data.value.seats.sum, price: data.value.price.sum, campaignId: data.key[data.key.length - 1][data.key[data.key.length - 1].length - 1], time: data.value.time };
    },
    handleResize: function handleResize() {
      if (this.seatsPlaceholder >= 3) {
        if (this.placesSwiper.snapGrid.length > 1) {
          this.placesSliderEnd = false;
          this.placesSliderSlides = this.placesSwiper.snapGrid.length;
          this.placesSwiper.slideTo(0, 500, false);
        }
      }
    },
    // checks if a particular date is fully booked
    dateFullyBooked: function dateFullyBooked(date) {
      var fullyBooked = true;
      for (var key in date) {
        if (date[key].seats !== 0) {
          fullyBooked = false;
          break;
        }
      }
      return fullyBooked;
    },
    // checks if all dates are fully booked
    allDatesFullyBooked: function allDatesFullyBooked() {
      var fullyBooked = true;
      for (var i in this.campData) {
        if (!this.dateFullyBooked(this.campData[i].showTimes)) {
          fullyBooked = false;
          break;
        }
      }
      return fullyBooked;
    },
    showAllDatesFullyBookedMsg: function showAllDatesFullyBookedMsg() {
      var errorMsg = this.$lang.messages.err7;
      if (this.selectedOptions.experienceName === 'Theatre') {
        errorMsg = this.$lang.messages.err8;
      }
      this.$store.commit('SET_DISPLAY_NOTIFICATION', {
        show: true,
        msg: errorMsg,
        state: false
      });
    }
  },
  filters: {
    formatHours: function formatHours(date) {
      var ampm = date >= 12 ? 'pm' : 'am';
      date = date % 12;
      date = date ? date : 12;
      var strTime = date + ampm;
      return strTime;
    }
  },
  mounted: function mounted() {
    this.selectedExpId = this.$route.params.playlistId;
    this.$store.dispatch('LOAD_ITEMS', this.selectedExpId);
    this.$store.dispatch('LOAD_SCHEDULE', 'home');
    this.selectedOptions.experienceId = this.selectedExpId;
    this.selectedOptions.experienceName = this.$route.params.playlistName;

    if (this.userLoggedIn) {
      this.verificationPh = this.$lang.messages.checkout_ph;
      this.username = this.$localStorage.get('username');
    }

    // start end date calculated with dayjs
    var seatCampaignParams = {
      id: this.selectedExpId,
      name: 'booking',
      beginDate: this.campBeginDay.startOf('day').toISOString(),
      endDate: this.campEndDay.endOf('day').toISOString()
    };
    this.$store.dispatch('LOAD_SEAT_CAMPAIGN', seatCampaignParams);
    window.addEventListener('resize', this.handleResize);
  }
});

/***/ }),

/***/ "fDzi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gFsy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'logoutModal',
  data: function data() {
    return {
      cancelBtnHighlighted: false,
      cancelTransitionClass: 'bb-transition2'
    };
  },

  methods: {
    confirmLogout: function confirmLogout() {
      this.$store.commit('SET_LOGGEDIN', false);
      this.$localStorage.remove('username');
      this.$localStorage.remove('token');
      this.$localStorage.remove('profileId');
      this.cancelLogout();

      if (this.$route.name === 'Checkout') {
        this.$router.push({ name: 'Home' });
      }
    },
    highlightCancelBtn: function highlightCancelBtn() {
      this.cancelBtnHighlighted = true;
      var self = this;
      setTimeout(function () {
        self.cancelBtnHighlighted = false;
      }, this.$utilities.getTransitionDurationOfClass('.' + this.cancelTransitionClass) * 1000);
    },
    cancelLogout: function cancelLogout() {
      this.$store.commit('SET_SHOW_LOGOUT_MODAL', false);
      this.$emit('cancelLogoutEmit');
    }
  }
});

/***/ }),

/***/ "gImT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex mx-auto bb-jcc bb-aic\nbb-xl-jcl"},[_c('div',{staticClass:"bb-pointer inline-block bb-xl-mln2pt5",class:{ 'bb-op0': _vm.sliderStart},on:{"click":_vm.slidePrev}},[_c('i',{staticClass:"material-icons bb-fs2pt17 bb-fc1 bb-usnone"},[_vm._v("")])]),_vm._v(" "),_c('div',{staticClass:"inline-block bb-w15 bb-mid-w30"},[_c('swiper',{ref:"mySwiper",attrs:{"options":_vm.swiperOption}},_vm._l((_vm.swiperData),function(movie){return _c('swiper-slide',{key:movie.value._id,staticClass:"center"},[_c('img',{staticClass:"bb-h13pt5",attrs:{"src":_vm.getImageUrl(movie.doc.uri, _vm.imageName)}})])}))],1),_vm._v(" "),_c('div',{staticClass:"bb-pointer inline-block",class:{ 'bb-op0pt3': _vm.sliderEnd},on:{"click":_vm.slideNext}},[_c('i',{staticClass:"material-icons bb-fs2pt17 bb-fc1 bb-usnone"},[_vm._v("")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hEVc":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "hPsX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'paymentSuccess'
});

/***/ }),

/***/ "jsB1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_logoutModal_vue__ = __webpack_require__("gFsy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57c9f1ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_logoutModal_vue__ = __webpack_require__("KsxP");
function injectStyle (ssrContext) {
  __webpack_require__("ajUp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57c9f1ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_logoutModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57c9f1ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_logoutModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jx1M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'paymentFail'
});

/***/ }),

/***/ "kQn/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lOSF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',{staticClass:"relative mx3 bb-mt2pt56"},[_c('div',{staticClass:"bb-pl20p bb-xl-pl0 bb-pr20p bb-xl-pr40p bb-min-h20\n      bb-ff2 bb-fs1pt2 bb-fc1 bb-ofy-auto bb-hyphens-auto border-box center bb-xl-justify",attrs:{"id":"scrollView"}},[_c('div',{staticClass:"bb-ff2 bb-fs1pt2 bb-fc2"},[_vm._v("\n        "+_vm._s(_vm.$lang.messages.refund_pol)+"\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"absolute bottom-0 left-0 right-0 bb-h25 bb-gradient1\n      bb-events-none bb-transition2",attrs:{"id":"scrollGradient"}})]),_vm._v(" "),_c('div',{staticClass:"absolute left-0 right-0 top-0 bottom-0 bb-zindexn1 bb-bc-black"})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bb-ff2 bb-fs1pt29 bb-fc3"},[_vm._v("\n        Bigbang doesn’t want you to miss out on a spectacular experience.\n        However, we’re here to help if you wish to cancel your booking. \n        "),_c('br'),_c('br'),_vm._v("\n        After your online booking, the payment card used will be checked for\n        validity, and the Bigbang crew will be expecting to see you at the\n        time and date of your booking. \n        "),_c('br'),_c('br'),_vm._v("\n        Payments are only executed once you show up to your allotted booking\n        at Bigbang. In cases of no-show, the payment will be canceled after\n        one business day. \n      ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lS6+":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE3LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSIyMy42cHgiCgkgaGVpZ2h0PSIxOS4xODhweCIgdmlld0JveD0iMCAwIDIzLjYgMTkuMTg4IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyMy42IDE5LjE4OCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgZmlsbD0iI2NjY2NjYyI+CjxnIGlkPSJMYXllcl8yIj4KPC9nPgo8ZyBpZD0iTGF5ZXJfMSI+CjwvZz4KPGcgaWQ9Ikd1aWRlIj4KCTxnPgoJCTxnPgoJCQk8cGF0aCBkPSJNMjMuNiwyLjI2OWMtMC44NjUsMC4zODQtMS44MDEsMC42NDktMi43OCwwLjc2NmMxLjAwMS0wLjYsMS43NjQtMS41NSwyLjEzMS0yLjY4M2MtMC45MzcsMC41NTUtMS45NzMsMC45Ni0zLjA4MywxLjE3NQoJCQkJQzE4Ljk5MSwwLjU5LDE3LjczLDAsMTYuMzQsMGMtMi42NzEsMC00Ljg0LDIuMTctNC44NCw0Ljg0NGMwLDAuMzgyLDAuMDQ0LDAuNzQ5LDAuMTI0LDEuMTA0CgkJCQljLTQuMDI2LTAuMjAzLTcuNTktMi4xMjgtOS45ODItNS4wNjJDMS4yMjQsMS42LDAuOTg2LDIuNDM2LDAuOTg2LDMuMzIzYzAsMS42NzksMC44NTcsMy4xNjUsMi4xNTMsNC4wMjgKCQkJCWMtMC43OTMtMC4wMi0xLjUzNC0wLjI0My0yLjE4OC0wLjYwNXYwLjA1OWMwLDIuMzQ5LDEuNjcsNC4zMDksMy44ODEsNC43NTdjLTAuNDA0LDAuMTA3LTAuODM1LDAuMTY0LTEuMjc0LDAuMTY0CgkJCQljLTAuMzEsMC0wLjYxMi0wLjAyOC0wLjkxNC0wLjA4NWMwLjYxOSwxLjkyNSwyLjQwNCwzLjMyMiw0LjUyMiwzLjM2NmMtMS42NTcsMS4yOTctMy43NDYsMi4wNjktNi4wMTQsMi4wNjkKCQkJCWMtMC4zODksMC0wLjc3MS0wLjAyMi0xLjE1Mi0wLjA2NWMyLjE0NiwxLjM3Nyw0LjY4OCwyLjE3Niw3LjQyNCwyLjE3NmM4LjkwMSwwLDEzLjc3LTcuMzgxLDEzLjc3LTEzLjc4MUwyMS4xOCw0Ljc3OQoJCQkJQzIyLjEzMSw0LjA5NCwyMi45NTEsMy4yNDQsMjMuNiwyLjI2OUwyMy42LDIuMjY5eiIvPgoJCTwvZz4KCTwvZz4KPC9nPgo8ZyBpZD0iTGF5ZXJfNCIgZGlzcGxheT0ibm9uZSI+CjwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "lnS6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mYO3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed left-0 right-0 bb-min-h2pt5 bb-lh2pt5 center bb-ff3 bb-fs1pt13 bb-fc1 bb-transition2\n\tbb-zindex2",class:[ _vm.success ? 'bb-bc6' : 'bb-bc7' ]},[_vm._v("\n\t"+_vm._s(_vm.msg)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mzkE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__ = __webpack_require__("ce18");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cdd8ea5e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("vAVH");
function injectStyle (ssrContext) {
  __webpack_require__("kQn/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cdd8ea5e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cdd8ea5e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "olkN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sdk_vks_sdk__ = __webpack_require__("WTob");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persist__ = __webpack_require__("v/L+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_persist__);





//using vue-presist plugin to avoid using localstorage without Json parsing,
//having options as localstor for vue-localstorage and reduced storage to
//selectedOptions
var vuexLocal = new __WEBPACK_IMPORTED_MODULE_3_vuex_persist___default.a({
  storage: localStorage,
  reducer: function reducer(state) {
    return { selectedOptions: state.selectedOptions, userInfo: state.userInfo };
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    init: false,
    nowShowingSchedule: null,
    comingSoonSchedule: null,
    subscribe: null,
    requestError: null,
    activity: null,
    userToken: null,
    items: null,
    homeData: null,
    tokenError: null,
    voucherActivity: null,
    voucherError: null,
    phoneNumError: null,
    payfortError: null,
    loggedIn: false,
    seatCampaign: null,
    campaignError: null,
    showLogoutModal: false,
    showModal: false,
    selectedOptions: null,
    displayNotification: null,
    userInfo: null,
    userCredentials: null,
    bookingActivity: null
  },
  mutations: {
    SET_INIT: function SET_INIT(state, data) {
      state.init = data;
    },
    SET_HOME_DATA: function SET_HOME_DATA(state, data) {
      state.homeData = data;
    },
    SET_SUBSCRIBE: function SET_SUBSCRIBE(state, data) {
      state.subscribe = data;
    },
    SET_REQUEST_ERROR: function SET_REQUEST_ERROR(state, data) {
      state.requestError = data;
    },
    SET_ACTIVITY: function SET_ACTIVITY(state, data) {
      state.activity = data;
    },
    SET_VOUCHER_ACTIVITY: function SET_VOUCHER_ACTIVITY(state, data) {
      state.voucherActivity = data;
    },
    SET_USER_TOKEN: function SET_USER_TOKEN(state, data) {
      state.userToken = data;
    },
    SET_LOGGEDIN: function SET_LOGGEDIN(state, data) {
      state.loggedIn = data;
    },
    SET_ITEMS: function SET_ITEMS(state, data) {
      state.items = data;
    },
    SET_TOKEN_ERROR: function SET_TOKEN_ERROR(state, data) {
      state.tokenError = data;
    },
    SET_VOUCHER_ERROR: function SET_VOUCHER_ERROR(state, data) {
      state.voucherError = data;
    },
    SET_PHONE_ERROR: function SET_PHONE_ERROR(state, data) {
      state.phoneNumError = data;
    },
    SET_PAYFORT_ERROR: function SET_PAYFORT_ERROR(state, data) {
      state.payfortError = data;
    },
    SET_SEATS_CAMPAIGN: function SET_SEATS_CAMPAIGN(state, data) {
      state.seatCampaign = data;
    },
    SET_CAMPAIGN_ERROR: function SET_CAMPAIGN_ERROR(state, data) {
      state.campaignError = data;
    },
    SET_SHOW_LOGOUT_MODAL: function SET_SHOW_LOGOUT_MODAL(state, data) {
      state.showLogoutModal = data;
    },
    SET_SHOW_MODAL: function SET_SHOW_MODAL(state, data) {
      state.showModal = data;
    },
    SET_SELECTED_OPTIONS: function SET_SELECTED_OPTIONS(state, data) {
      state.selectedOptions = data;
    },
    SET_DISPLAY_NOTIFICATION: function SET_DISPLAY_NOTIFICATION(state, data) {
      state.displayNotification = data;
    },
    SET_USER_INFO: function SET_USER_INFO(state, data) {
      state.userInfo = data;
    },
    SET_USER_CREDENTIALS: function SET_USER_CREDENTIALS(state, data) {
      state.userCredentials = data;
    },
    SET_BOOKING_ACTIVITY: function SET_BOOKING_ACTIVITY(state, data) {
      state.bookingActivity = data;
    }
  },
  actions: {
    INIT: function INIT(context, opts) {
      __WEBPACK_IMPORTED_MODULE_2__sdk_vks_sdk__["a" /* default */].init(opts.domain, opts.outlet, opts.version, opts.opts).then(function (data) {
        context.commit('SET_INIT', true);
      }, function (error) {
        context.commit('SET_REQUEST_ERROR', error);
      });
    },
    LOAD_SCHEDULE: function LOAD_SCHEDULE(context, name) {
      __WEBPACK_IMPORTED_MODULE_2__sdk_vks_sdk__["a" /* default */].request.schedule(name, {
        metadata: true
      }).playlists().then(function (data) {
        context.commit('SET_HOME_DATA', data);
      }).catch(function (error) {
        context.commit('SET_REQUEST_ERROR', error);
      });
    },
    SUBSCRIBE: function SUBSCRIBE(context, params) {
      __WEBPACK_IMPORTED_MODULE_2__sdk_vks_sdk__["a" /* default */].request.subscribe(params).then(function (data) {
        context.commit('SET_SUBSCRIBE', data);
      }).catch(function (error) {
        context.commit('SET_SUBSCRIBE', error);
      });
    },
    LOAD_ITEMS: function LOAD_ITEMS(context, id) {
      __WEBPACK_IMPORTED_MODULE_2__sdk_vks_sdk__["a" /* default */].request.items(id).then(function (data) {
        context.commit('SET_ITEMS', data);
      }).catch(function (error) {
        context.commit('SET_REQUEST_ERROR', error);
      });
    },
    LOAD_USER_TOKEN: function LOAD_USER_TOKEN(context, params) {
      __WEBPACK_IMPORTED_MODULE_2__sdk_vks_sdk__["a" /* default */].request.token(params).then(function (data) {
        context.commit('SET_USER_TOKEN', data);
      }).catch(function (error) {
        context.commit('SET_PHONE_ERROR', error);
      });
    },
    LOAD_TOKEN: function LOAD_TOKEN(context, params) {
      __WEBPACK_IMPORTED_MODULE_2__sdk_vks_sdk__["a" /* default */].request.token(params).then(function (data) {
        if (data.success) {
          var dataParams = {
            uParams: {
              token: data.token,
              email: params.email,
              first_name: params.first_name,
              last_name: params.last_name
            },
            pId: data.id
          };
          __WEBPACK_IMPORTED_MODULE_2__sdk_vks_sdk__["a" /* default */].request.update(dataParams.uParams, dataParams.pId).then(function (data) {
            if (data.success) {
              var loginParams = { profileId: dataParams.pId, profileToken: dataParams.uParams.token, username: dataParams.uParams.first_name, lastname: dataParams.uParams.last_name };
              context.commit('SET_USER_CREDENTIALS', loginParams);
            }
          }).catch(function (error) {
            context.commit('SET_REQUEST_ERROR', error);
          });
        }
      }).catch(function (error) {
        context.commit('SET_TOKEN_ERROR', error);
      });
    },
    LOAD_PAYFORT: function LOAD_PAYFORT(context, params) {
      var payParams = {
        metric: context.state.selectedOptions.selectedPlaces,
        booking: { time: context.state.selectedOptions.sessionData.time,
          seats: { metric: context.state.selectedOptions.selectedPlaces * -1 } },
        payment: { type: 'redirect',
          return_url: window.location.origin + '/:media_id/:activity_id/confirmation',
          currency: 'USD',
          language: 'en',
          amount: context.state.selectedOptions.selectedPlaces * context.state.selectedOptions.sessionData.price
        },
        token: params.token,
        campaign_id: context.state.selectedOptions.sessionData.campaignId
      };
      __WEBPACK_IMPORTED_MODULE_2__sdk_vks_sdk__["a" /* default */].request.activity(params.pId, 'booking', context.state.selectedOptions.experienceId, payParams).then(function (data) {
        if (data.success) {
          context.commit('SET_ACTIVITY', data);
        }
      }).catch(function (error) {
        context.commit('SET_PAYFORT_ERROR', error);
      });
    },
    LOAD_VOUCHER: function LOAD_VOUCHER(context, params) {
      var payParams = {
        metric: context.state.selectedOptions.selectedPlaces,
        booking: { time: context.state.selectedOptions.sessionData.time,
          seats: { metric: context.state.selectedOptions.selectedPlaces * -1 } },
        payment: { type: 'inline',
          code: params.voucherCode
        },
        token: params.profileToken,
        campaign_id: context.state.selectedOptions.sessionData.campaignId
      };
      __WEBPACK_IMPORTED_MODULE_2__sdk_vks_sdk__["a" /* default */].request.activity(params.profileId, 'booking', context.state.selectedOptions.experienceId, payParams).then(function (bookData) {
        if (bookData.success) {
          __WEBPACK_IMPORTED_MODULE_2__sdk_vks_sdk__["a" /* default */].request.voucher(bookData.req[bookData.req.name], bookData.req.headers).then(function (data) {
            context.commit('SET_VOUCHER_ACTIVITY', bookData);
          }).catch(function (error) {
            context.commit('SET_VOUCHER_ERROR', error);
          });
        }
      }).catch(function (error) {
        context.commit('SET_VOUCHER_ERROR', error);
      });
    },
    LOAD_SEAT_CAMPAIGN: function LOAD_SEAT_CAMPAIGN(context, params) {
      var campaignParams = {
        begin_date: params.beginDate,
        end_date: params.endDate
      };
      __WEBPACK_IMPORTED_MODULE_2__sdk_vks_sdk__["a" /* default */].request.campaign(params.id, params.name, campaignParams).then(function (data) {
        context.commit('SET_SEATS_CAMPAIGN', data);
      }).catch(function (error) {
        context.commit('SET_CAMPAIGN_ERROR', error);
      });
    },
    LOAD_BOOKING_ACTIVITY: function LOAD_BOOKING_ACTIVITY(context, params) {
      __WEBPACK_IMPORTED_MODULE_2__sdk_vks_sdk__["a" /* default */].get('/' + params.id + '/activity', {
        token: params.token
      }).then(__WEBPACK_IMPORTED_MODULE_2__sdk_vks_sdk__["a" /* default */].format.rows).then(function (data) {
        context.commit('SET_BOOKING_ACTIVITY', data);
      }).catch(function (error) {
        context.commit('SET_BOOKING_ACTIVITY', {});
      });
    }
  },
  getters: {
    getInit: function getInit(state) {
      return state.init;
    },
    getNowShowingSchedule: function getNowShowingSchedule(state) {
      return state.nowShowingSchedule;
    },
    getComingSoonSchedule: function getComingSoonSchedule(state) {
      return state.comingSoonSchedule;
    },
    getImageUrl: function getImageUrl(state) {
      return function (uri, name) {
        return __WEBPACK_IMPORTED_MODULE_2__sdk_vks_sdk__["a" /* default */].getImageUrl(uri, name);
      };
    },
    getHomeData: function getHomeData(state) {
      return state.homeData;
    },
    getSubscribe: function getSubscribe(state) {
      return state.subscribe;
    },
    getRequestError: function getRequestError(state) {
      return state.requestError;
    },
    getActivity: function getActivity(state) {
      return state.activity;
    },
    getVoucherActivity: function getVoucherActivity(state) {
      return state.voucherActivity;
    },
    getUserToken: function getUserToken(state) {
      return state.userToken;
    },
    getLoggedIn: function getLoggedIn(state) {
      return state.loggedIn;
    },
    getItems: function getItems(state) {
      return state.items;
    },
    getTokenError: function getTokenError(state) {
      return state.tokenError;
    },
    getVoucherError: function getVoucherError(state) {
      return state.voucherError;
    },
    getPhoneError: function getPhoneError(state) {
      return state.phoneNumError;
    },
    getSeatCampaign: function getSeatCampaign(state) {
      return state.seatCampaign;
    },
    getCampaignError: function getCampaignError(state) {
      return state.campaignError;
    },
    getPayfortError: function getPayfortError(state) {
      return state.payfortError;
    },
    getShowLogoutModal: function getShowLogoutModal(state) {
      return state.showLogoutModal;
    },
    getShowModal: function getShowModal(state) {
      return state.showModal;
    },
    getSelectedOptions: function getSelectedOptions(state) {
      return state.selectedOptions;
    },
    getDisplayNotification: function getDisplayNotification(state) {
      return state.displayNotification;
    },
    getUserInfo: function getUserInfo(state) {
      return state.userInfo;
    },
    getUserCredentials: function getUserCredentials(state) {
      return state.userCredentials;
    },
    getBookingActivity: function getBookingActivity(state) {
      return state.bookingActivity;
    }
  },
  plugins: [vuexLocal.plugin]
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "pYmz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_swiper_vue__ = __webpack_require__("7oBO");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3e617127_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_swiper_vue__ = __webpack_require__("Hpn/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_swiper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3e617127_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_swiper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "srjS":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNy4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHdpZHRoPSIyMC40NTRweCIgaGVpZ2h0PSIyMC44OTFweCIgdmlld0JveD0iMCAwIDIwLjQ1NCAyMC44OTEiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDIwLjQ1NCAyMC44OTEiIHhtbDpzcGFjZT0icHJlc2VydmUiIGZpbGw9IiNmZmZmZmYiPg0KPGcgaWQ9IkxheWVyXzIiPg0KPC9nPg0KPGcgaWQ9IkxheWVyXzEiPg0KCTxwYXRoIGQ9Ik0xMy40NzEsMTEuMTg0bC0wLjc0LTAuNzM5bDAuNzQtMC43MzlsNi42OC02LjY4YzAuNDA3LTAuNDA3LDAuNDA0LTEuMDY5LTAuMDA3LTEuNDczbC0xLjI3Ny0xLjI1NA0KCQljLTAuNDExLTAuNDAzLTEuMDc4LTAuMzk4LTEuNDg0LDAuMDA4bC03LjE1NSw3LjE4OUwzLjA3MywwLjMwOUMyLjY2Ny0wLjA5OSwxLjk5OS0wLjEwMywxLjU4OSwwLjNMMC4zMSwxLjU1NA0KCQlDLTAuMTAxLDEuOTU3LTAuMTA0LDIuNjIsMC4zMDMsMy4wMjdsNi42OCw2LjY4bDAuNzQsMC43MzlsLTAuNzQsMC43MzlsLTYuNjgsNi42OGMtMC40MDcsMC40MDctMC40MDQsMS4wNjksMC4wMDcsMS40NzMNCgkJbDEuMjc3LDEuMjU0YzAuNDExLDAuNDAzLDEuMDc4LDAuMzk4LDEuNDg0LTAuMDA4bDcuMTU1LTcuMTg5bDcuMTU0LDcuMTg4YzAuNDA2LDAuNDA4LDEuMDc0LDAuNDEyLDEuNDg0LDAuMDA5bDEuMjc4LTEuMjU0DQoJCWMwLjQxMS0wLjQwMywwLjQxNC0xLjA2NiwwLjAwNy0xLjQ3M0wxMy40NzEsMTEuMTg0eiIvPg0KPC9nPg0KPGcgaWQ9IkxheWVyXzQiIGRpc3BsYXk9Im5vbmUiPg0KPC9nPg0KPGcgaWQ9IkxheWVyXzMiIGRpc3BsYXk9Im5vbmUiPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ "uHdg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uTBe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v2ns":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vAVH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bb-px2pt6 bb-pb2pt56 border-box bb-w100p"},[_c('div',{staticClass:"bb-w100p bb-h0pt1 bb-bc13 absolute left-0 right-0"}),_vm._v(" "),_c('div',{staticClass:"bb-mt2pt56"},[_c('div',{staticClass:"lg-col center mb4 bb-lg-mb0"},[_c('div',{staticClass:"bb-lg-inline-block mb3 bb-lg-mb0 bb-ff3 bb-fs1 bb-lg-mr4"},[_c('router-link',{staticClass:"text-decoration-none bb-fc2-hover bb-transition2",class:[_vm.$route.name === 'RefundPolicy' ? 'bb-fc2' : 'bb-fc3'],attrs:{"to":{name: 'RefundPolicy'}}},[_vm._v("\n          Refund Policy\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"bb-lg-inline-block mb3 bb-lg-mb0 bb-ff3 bb-fs1 bb-lg-mr4"},[_c('router-link',{staticClass:"text-decoration-none bb-fc2-hover bb-transition2",class:[_vm.$route.name === 'PrivacyPolicy' ? 'bb-fc2' : 'bb-fc3'],attrs:{"to":{name: 'PrivacyPolicy'}}},[_vm._v("\n          Privacy Policy\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"bb-lg-inline-block mb3 bb-lg-mb0 bb-ff3 bb-fs1 bb-lg-mr4"},[_c('router-link',{staticClass:"\n        text-decoration-none bb-fc2-hover bb-transition2",class:[_vm.$route.name === 'ContactUs' ? 'bb-fc2' : 'bb-fc3'],attrs:{"to":{name: 'ContactUs'}}},[_vm._v("\n          Contact Us\n        ")])],1)]),_vm._v(" "),_c('div',{staticClass:"lg-col-right center"},_vm._l((_vm.socialMediaData),function(socialMediaObj,i){return _c('div',{staticClass:"inline-block"},[_c('a',{staticClass:"block relative",class:[ i !== 0 ? 'bb-ml5 bb-lg-ml3' : '' ],attrs:{"href":socialMediaObj.url,"target":"_blank"}},[_c('img',{class:socialMediaObj.widthClass,attrs:{"src":_vm.imagePath(socialMediaObj.imgUrl)}}),_vm._v(" "),_c('img',{staticClass:"absolute left-0 top-0 bb-op0 bb-op1-hover bb-transition1",class:socialMediaObj.widthClass,attrs:{"src":_vm.imagePath(socialMediaObj.imgUrlHovered)}})])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vp4Z":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/BBang-Studios-Map.754dfee.jpg";

/***/ }),

/***/ "wUZA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__("FGQs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f6d62d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__("Rhxi");
function injectStyle (ssrContext) {
  __webpack_require__("WH9s")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f6d62d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f6d62d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wqBJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Header'
});

/***/ }),

/***/ "x8Pr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__("Cz8s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_footer__ = __webpack_require__("mzkE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loginModal__ = __webpack_require__("DIKo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_logoutModal__ = __webpack_require__("jsB1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_miniNotification__ = __webpack_require__("LIyj");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    'top': __WEBPACK_IMPORTED_MODULE_0__components_header__["a" /* default */],
    'bot': __WEBPACK_IMPORTED_MODULE_1__components_footer__["a" /* default */],
    'login-modal': __WEBPACK_IMPORTED_MODULE_2__components_loginModal__["a" /* default */],
    'logout-modal': __WEBPACK_IMPORTED_MODULE_3__components_logoutModal__["a" /* default */],
    'mini-notification': __WEBPACK_IMPORTED_MODULE_4__components_miniNotification__["a" /* default */]
  },
  data: function data() {
    return {
      timer: null
    };
  },

  methods: {
    cancelLogin: function cancelLogin() {
      this.$store.commit('SET_SHOW_MODAL', false);
    },
    displayNoti: function displayNoti(msgs) {
      this.$store.commit('SET_DISPLAY_NOTIFICATION', { show: true, msg: msgs, state: false });
    },
    cancelLogout: function cancelLogout() {
      this.$store.commit('SET_SHOW_LOGOUT_MODAL', false);
    }
  },
  computed: {
    showModal: function showModal() {
      return this.$store.getters.getShowModal;
    },
    selectedOptions: function selectedOptions() {
      return this.$store.getters.getSelectedOptions;
    },
    showLogoutModal: function showLogoutModal() {
      return this.$store.getters.getShowLogoutModal;
    },
    displayNotification: function displayNotification() {
      return this.$store.getters.getDisplayNotification;
    }
  },
  watch: {
    displayNotification: function displayNotification() {
      var self = this;
      window.clearTimeout(this.timer);
      self.timer = window.setTimeout(function () {
        self.$store.commit('SET_DISPLAY_NOTIFICATION', { show: false });
      }, 3000);
    }
  },
  created: function created() {
    if (this.$localStorage.get('token') && this.$localStorage.get('profileId')) {
      this.$store.commit('SET_LOGGEDIN', true);
    }
  }
});

/***/ }),

/***/ "yVls":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-container bb-h28 bb-lg-h25 bb-fs0 bb-w100vw bb-of-hidden relative"},[_c('div',{staticClass:"slider relative bb-hcr mt3 center",class:_vm.transitionClass,style:('width:' + _vm.sliderWidth)},[_c('div',{staticClass:"slider-inner",attrs:{"swipe-added":"false"}},_vm._l(((_vm.flatMode ? 1 : 3)),function(n){return _c('div',{staticClass:"slides-container relative inline-block bb-fs0 bb-perspective100",class:[ _vm.transitionClass, Math.ceil((_vm.activeSlideIndex +
        (_vm.sliderData.length & 2 !== 0 ? 1 : 0)) / _vm.sliderData.length) === n ? 'bb-zindex1' : '' ],style:('right:' + _vm.calcSliderPosition(0) + ';perspective-origin:'+_vm.calcPerspectiveOrigin(n)+'%')},[(n === 1 && _vm.sliderData.length % 2 === 0 && !_vm.flatMode)?_c('div',{staticClass:"evenifier-slide slide inline-block align-top",class:[ _vm.slideWidthClass, _vm.transitionClass ],style:('transform: rotateY(' + _vm.calcRotationDeg(0) +'deg)'),attrs:{"index":0},on:{"mouseenter":_vm.slideHovered}},[_c('div',{staticClass:"relative bb-pointer\n            bb-bgs-cover bb-bgp-center bb-bg-no-repeat bb-shadow1",class:_vm.slideHeightClass,style:('background-image:' +
            _vm.getBgImageUrlString(_vm.sliderData[_vm.sliderData.length - 1].value._id,_vm.imageName))}),_vm._v(" "),_c('div',{staticClass:"mt2 bb-fs1 left-align"},[_vm._v("\n            "+_vm._s(_vm.sliderData[_vm.sliderData.length - 1].doc.synopsis)+"\n          ")]),_vm._v(" "),(_vm.sliderData[_vm.sliderData.length - 1].doc.video_length)?_c('div',{staticClass:"mt2 bb-fs1p5 left-align"},[_vm._v("\n            "+_vm._s(_vm.$utilities.displayTime(_vm.sliderData[_vm.sliderData.length - 1].doc.video_length /
              1000))+"\n          ")]):_vm._e()]):_vm._e(),_vm._v(" "),_vm._l((_vm.sliderData),function(data,dataIndex){return _c('div',{staticClass:"slide inline-block relative align-top",class:[ _vm.slideWidthClass, _vm.transitionClass, _vm.flatMode ? _vm.slidePaddingClass : '',
          _vm.calcIndex(dataIndex, n) > _vm.activeSlideIndex ? 'bb-zindex0' : 'bb-zindex1' ],style:('transform: rotateY(' + _vm.calcRotationDeg(_vm.calcIndex(dataIndex, n)) + 'deg)'),attrs:{"index":_vm.calcIndex(dataIndex, n)},on:{"mouseenter":_vm.slideHovered}},[_c('div',{staticClass:"relative bb-pointer\n            bb-bgs-cover bb-bgp-center bb-bg-no-repeat bb-shadow1",class:_vm.slideHeightClass,style:('background-image:' + _vm.getBgImageUrlString(data.value._id, _vm.imageName)),on:{"click":_vm.slidePosterClicked}}),_vm._v(" "),_c('div',{staticClass:"mt2 bb-ff2 bb-fs1 bb-fc1 left-align"},[_vm._v("\n            "+_vm._s(data.doc.synopsis)+"\n          ")]),_vm._v(" "),(data.doc.video_length)?_c('div',{staticClass:"mt2 bb-ff2 bb-fs1pt13 bb-fc2 left-align"},[_vm._v("\n            "+_vm._s(_vm.$utilities.displayTime(data.doc.video_length / 1000))+"\n          ")]):_vm._e()])})],2)}))]),_vm._v(" "),_c('div',{staticClass:"slider-indicators bb-fs0 center bb-mt1pt7 sm-hide md-hide\n    lg-hide xl-hide absolute bottom-0 mb1 left-0 right-0"},_vm._l((_vm.sliderData.length),function(n){return _c('div',{staticClass:"inline-block circle border-box bb-w0pt75 bb-h0pt75 bb-brd3",class:[ n > 1 ? 'ml1' : '', n - 1 === _vm.activeSlideIndex % _vm.sliderData.length ? 'bb-bc2' : '',
      _vm.sliderData.length < 2 ? 'display-none' : '']})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ycmV":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./assets/icons/360.svg": "Dwzj",
	"./assets/icons/arrow-down.svg": "/7LY",
	"./assets/icons/bigbang-icon.svg": "hEVc",
	"./assets/icons/bigbang-logo01.svg": "dYG7",
	"./assets/icons/bigbang-logo02.svg": "H0Ad",
	"./assets/icons/close.svg": "srjS",
	"./assets/icons/facebook.svg": "85DX",
	"./assets/icons/facebook_pink.svg": "HH8T",
	"./assets/icons/instagram.svg": "OCqi",
	"./assets/icons/instagram_pink.svg": "5Bov",
	"./assets/icons/twitter.svg": "lS6+",
	"./assets/icons/twitter_pink.svg": "AIlL",
	"./assets/images/BBang-Studios-Map.jpg": "vp4Z",
	"./assets/images/green-loader.svg": "8cbe",
	"./assets/images/loader.svg": "OTU4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ycmV";

/***/ }),

/***/ "yuJj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Checkout',
  data: function data() {
    return {
      loadingPayfort: false,
      loadingVoucher: false,
      inputVoucherActive: false,
      voucherCode: '',
      invalidVoucherCode: false,
      formDataReceived: false
    };
  },

  computed: {
    formData: function formData() {
      if (this.$store.getters.getActivity !== null) {
        this.formDataReceived = true;
        return this.$store.getters.getActivity;
      }
    },
    voucherFeedback: function voucherFeedback() {
      return this.$store.getters.getVoucherActivity;
    },
    selectedOptions: function selectedOptions() {
      return this.$store.getters.getSelectedOptions;
    },
    voucherError: function voucherError() {
      return this.$store.getters.getVoucherError;
    }
  },
  watch: {
    formDataReceived: function formDataReceived() {
      this.loading = false;
      this.$nextTick(function () {
        document.getElementById('form1').submit();
      });
    },
    voucherError: function voucherError() {
      this.loadingVoucher = false;
      this.invalidVoucherCode = true;
      this.$store.commit('SET_DISPLAY_NOTIFICATION', { show: true,
        msg: this.$lang.messages.err4, state: false });
    },
    voucherCode: function voucherCode() {
      if (this.invalidVoucherCode) {
        this.invalidVoucherCode = false;
      }
    },
    voucherFeedback: function voucherFeedback() {
      this.$router.push({
        path: '/${this.selectedOptions.experienceId}/${this.voucherFeedback.id}/confirmation'
      });
    }
  },
  methods: {
    payment: function payment() {
      this.loadingPayfort = true;
      var params = {
        token: this.$localStorage.get('token'),
        pId: this.$localStorage.get('profileId')
      };
      this.$store.dispatch('LOAD_PAYFORT', params);
    },
    voucher: function voucher() {
      this.loadingVoucher = true;
      if (this.voucherCode !== '') {
        var voucherParams = {
          voucherCode: this.voucherCode,
          profileId: this.$localStorage.get('profileId'),
          profileToken: this.$localStorage.get('token')
        };
        this.$store.dispatch('LOAD_VOUCHER', voucherParams);
      } else {
        this.loadingVoucher = false;
        this.invalidVoucherCode = true;
        this.$store.commit('SET_DISPLAY_NOTIFICATION', { show: true,
          msg: this.$lang.messages.err4, state: false });
      }
    },
    resetPlaceholder: function resetPlaceholder(event, placeholder) {
      event.target.placeholder = placeholder;
    },
    blurVoucherPlaceholder: function blurVoucherPlaceholder(event) {
      if (event.target.value.length <= 0) {
        this.inputVoucherActive = false;
      }
    },
    inputVoucherClicked: function inputVoucherClicked() {
      this.inputVoucherActive = true;
    },
    resetValidation: function resetValidation() {
      if (this.invalidVoucherCode) {
        this.invalidVoucherCode = false;
      }
    }
  },
  created: function created() {
    if (this.selectedOptions && this.selectedOptions.experienceId) {
      this.forceLogin();
    } else {
      this.$router.push({ name: 'Home' });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.loadingPayfort = false;
    this.loadingVoucher = false;
  }
});

/***/ }),

/***/ "z0aN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bb-px2pt6 border-box"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.userLoggedIn),expression:"userLoggedIn"}],staticClass:"clearfix"},[_c('div',{staticClass:"xl-col xl-col-6 bb-xl-max-w55 center bb-xl-left-align"},[_c('div',{staticClass:"relative bb-mt3pt56"},[_c('div',{staticClass:"absolute bb-vcr bb-bc2 bb-w0pt5 bb-h0pt5 bb-br0pt5 bb-leftn1\n        xs-hide sm-hide md-hide lg-hide"}),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1pt2 bb-fc1"},[_vm._v("\n          "+_vm._s(_vm.$lang.messages.select_experience)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"xl-col bb-ff2 bb-fs1pt2 bb-fc4 mt2"},[_vm._v("\n        VR EXPERIENCE :\n        ")]),_vm._v(" "),_c('div',{staticClass:"xl-col xl-col-8 bb-ff2 bb-fs1pt2 bb-fc3 mt2 bb-xl-mt2 bb-xl-pl2 border-box"},[_vm._v("\n          "+_vm._s(_vm.selectedOptions.experienceName)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"xl-col bb-ff2 bb-fs1pt2 bb-fc4 mt2"},[_vm._v("\n          "+_vm._s(_vm.$lang.messages.your_booking)+" :\n        ")]),_vm._v(" "),_c('div',{staticClass:"xl-col xl-col-8 bb-ff2 bb-fs1pt2 bb-fc3 mt2 bb-xl-mt2 bb-xl-pl2 border-box"},[_vm._v("\n          "+_vm._s(_vm.selectedOptions.timestamp)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"xl-col bb-ff2 bb-fs1pt2 bb-fc4 mt2"},[_vm._v("\n          "+_vm._s(_vm.$lang.messages.total_payment)+" :\n        ")]),_vm._v(" "),_c('div',{staticClass:"xl-col xl-col-3 bb-ff2 bb-fs1pt2 bb-fc3 mt2 bb-xl-pl2"},[_vm._v("\n          $"+_vm._s(_vm.selectedOptions.selectedPlaces *
          _vm.selectedOptions.sessionData.price)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"xl-col xl-col-6 bb-xl-max-w55 center bb-xl-left-align"},[_c('div',{staticClass:"relative bb-mt3pt56"},[_c('div',{staticClass:"absolute bb-vcr bb-bc2 bb-w0pt5 bb-h0pt5 bb-br0pt5 bb-leftn1\n        xs-hide sm-hide md-hide lg-hide"}),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1pt2 bb-fc1"},[_vm._v("\n          "+_vm._s(_vm.$lang.messages.payment_method_title)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1pt29 bb-fc3 mt2"},[_vm._v("\n        "+_vm._s(_vm.$lang.messages.payment_method1)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"center mx-auto border-box bb-pointer bb-sm-bc-transp\n        bb-ff3 bb-fs1 bb-brd4 bb-h2pt8 bb-py1pt25 bb-lh0\n        bb-transition2 mb3 bb-mt1pt7 relative bb-mxw31pt3 bb-xl-ml0",class:[ _vm.loadingPayfort ? 'bb-fc13' : 'bb-bc9 bb-fc1 bb-sm-fc3 bb-fc1-hover' ],on:{"click":_vm.payment}},[_vm._v("\n        "+_vm._s(_vm.$lang.messages.pay_method1)+"\n        "),(_vm.loadingPayfort)?_c('div',{staticClass:"absolute bb-vhcr bb-h90p bb-w100p"},[_c('img',{staticClass:"bb-h100p",attrs:{"src":__webpack_require__("8cbe")}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"bb-ff2 bb-fs1pt29 bb-fc3 mt1"},[_vm._v("\n          "+_vm._s(_vm.$lang.messages.payment_method2)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"border-box bb-mxw31pt3 bb-xl-ml0 mt3 mx-auto relative"},[_c('div',{staticClass:"absolute left-0 bb-top1 bb-transform1 bb-fc1 bb-ff2 bb-zindex0",class:{'bb-transform2': _vm.inputVoucherActive}},[_vm._v("\n          "+_vm._s(_vm.$lang.messages.voucher_code)+"\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.voucherCode),expression:"voucherCode"}],staticClass:"bb-bc-transp border-box mx-auto\n          bb-ff2 bb-fs1 bb-w100p bb-h2pt8 bb-brd-top0\n          bb-brd-left0 bb-brd-right0 p0 bb-fc1 relative bb-zindex1",class:[_vm.invalidVoucherCode ? 'bb-brd5 bb-fc5' : 'bb-brd-bot1 bb-fc1'],attrs:{"type":"text"},domProps:{"value":(_vm.voucherCode)},on:{"blur":_vm.blurVoucherPlaceholder,"change":_vm.resetValidation,"focus":_vm.inputVoucherClicked,"input":function($event){if($event.target.composing){ return; }_vm.voucherCode=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"center mx-auto border-box bb-pointer bb-sm-bc-transp\n        bb-ff3 bb-fs1 bb-brd3 bb-mxw31pt3 bb-xl-ml0\n        bb-h2pt8 bb-py1pt25 bb-lh0 bb-transition2 bb-mt1pt7 relative",class:[ _vm.loadingVoucher ? 'bb-fc13' : 'bb-bc2 bb-fc1 bb-sm-fc2 bb-fc1-hover bb-bc2-hover' ],on:{"click":_vm.voucher}},[_vm._v("\n        "+_vm._s(_vm.$lang.messages.pay_method2)+"\n        "),(_vm.loadingVoucher)?_c('div',{staticClass:"absolute bb-vhcr bb-h90p bb-w100p"},[_c('img',{staticClass:"bb-h100p",attrs:{"src":__webpack_require__("OTU4")}})]):_vm._e()])])]),_vm._v(" "),(_vm.formData)?_c('form',{attrs:{"method":_vm.formData.req.method,"action":_vm.formData.req.url,"id":"form1"}},[_vm._l((_vm.formData.req.payfort),function(value,key){return _c('input',{attrs:{"type":"hidden","name":key},domProps:{"value":value}})}),_c('br')],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zBR+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zeKi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"center bb-mt2pt56\n    xl-col xl-col-5 bb-xl-ml2 bb-xl-left-align"},[_c('div',{staticClass:"bb-ff2 bb-fs1pt2 bb-fc1"},[_vm._v("\n     "+_vm._s(_vm.$lang.messages.address)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"bb-mt0pt81 bb-ff2 bb-fs1pt29 bb-fc3"},[_vm._v("\n      "+_vm._s(_vm.$lang.messages.address_loc_p1)),_c('br'),_vm._v(_vm._s(_vm.$lang.messages.address_loc_p2)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"mt2 bb-xl-mt1 bb-w100p"},[_c('div',{staticClass:"xs-hide sm-hide md-hide inline-block overflow-hidden bb-xl-hover-trigger2 bb-xl-pointer bb-max-w50 bb-w80p",on:{"click":function($event){_vm.showMap(true)}}},[_c('img',{staticClass:"bb-w100p bb-transition2",attrs:{"src":__webpack_require__("vp4Z")}})]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"center col-10 bb-max-w34 mx-auto bb-mt2pt56\n    lg-col-4\n    xl-col"},[_c('div',{staticClass:"bb-ff2 bb-fs1pt2 bb-fc1 bb-xl-left-align"},[_vm._v("\n      "+_vm._s(_vm.$lang.messages.email)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"bb-mt0pt81 bb-ff2 bb-fs1pt29 bb-fc3 bb-xl-left-align"},[_vm._v("\n      "+_vm._s(_vm.$lang.messages.email_add)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1pt2 bb-fc1 bb-xl-left-align mt2 bb-xl-mt1"},[_vm._v("\n      "+_vm._s(_vm.$lang.messages.phone)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"bb-mt0pt81 bb-ff2 bb-fs1pt29 bb-fc3 bb-xl-left-align"},[_vm._v("\n      "+_vm._s(_vm.$lang.messages.phone_num)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"bb-ff2 bb-fs1pt2 bb-fc1\n      bb-xl-left-align mt2 bb-xl-mt1"},[_vm._v("\n      "+_vm._s(_vm.$lang.messages.subscribe)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"border-box bb-mxw31pt3 bb-xl-ml0 mt3 mx-auto relative"},[_c('div',{staticClass:"absolute left-0 bb-top1 bb-transform1 bb-fc1 bb-ff2 bb-zindex0",class:{'bb-transform2': _vm.inputMailActive}},[_vm._v("\n        "+_vm._s(_vm.mailPlaceholder)+"\n      ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mailInput),expression:"mailInput"}],staticClass:"bb-bc-transp border-box mx-auto\n        bb-ff2 bb-fs1 bb-w100p bb-h2pt8 bb-brd-top0\n        bb-brd-left0 bb-brd-right0 p0 bb-fc1 relative bb-zindex1",class:[ _vm.invalidMail ? 'bb-brd5 bb-fc5' : 'bb-brd-bot1 bb-fc1' ],attrs:{"type":"text"},domProps:{"value":(_vm.mailInput)},on:{"blur":_vm.blurMailPlaceholder,"input":[function($event){if($event.target.composing){ return; }_vm.mailInput=$event.target.value},_vm.resetValidation],"focus":_vm.inputMailClicked}})]),_vm._v(" "),_c('div',{staticClass:"center mx-auto border-box bb-pointer bb-sm-bc-transp\n      bb-ff3 bb-fs1 bb-brd3 bb-mxw31pt3 bb-xl-ml0\n      bb-h2pt8 bb-py1pt25 bb-lh0 bb-transition2 bb-mt1pt7 relative",class:[ _vm.loadingMail ? 'bb-fc13' : 'bb-bc2 bb-fc1 bb-sm-fc2 bb-fc1-hover bb-bc2-hover' ],on:{"click":_vm.subscribeBtnClicked}},[_vm._v("\n      "+_vm._s(_vm.$lang.messages.send)+"\n      "),(_vm.loadingMail)?_c('div',{staticClass:"absolute bb-vhcr bb-h90p bb-w100p"},[_c('img',{staticClass:"bb-h100p",attrs:{"src":__webpack_require__("OTU4")}})]):_vm._e()])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.largeMap)?_c('div',{staticClass:"xs-hide sm-hide md-hide absolute top-0 left-0 bb-zindex1 bb-bc10 bb-h100vh bb-w100vw\n    bb-fullscreen bb-usnone",on:{"click":_vm.highlightCloseBtn}},[_c('div',{staticClass:"mx-auto relative bb-vcr bb-bc11 bb-fs0 bb-w24pt12 bb-xl-w70 bb-lg-w50 bb-md-w40"},[_c('img',{staticClass:"bb-w100p",attrs:{"src":__webpack_require__("vp4Z")}}),_vm._v(" "),_c('div',{staticClass:"bb-rightn1pt5 bb-topn1pt5 bb-br2 bb-w3 bb-h3 bb-bc7 absolute\n        bb-pointer",class:[_vm.cancelTransitionClass,
        _vm.closeBtnHighlighted ? 'bb-scale-1pt2' : '' ],on:{"click":function($event){_vm.showMap(false)}}},[_c('img',{staticClass:"bb-w1pt5 relative bb-vhcr",attrs:{"src":__webpack_require__("srjS")}})])])]):_vm._e()])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lg-hide xl-hide inline-block overflow-hidden bb-max-w50 bb-w80p"},[_c('img',{staticClass:"bb-w100p bb-transition2",attrs:{"src":__webpack_require__("vp4Z")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.ea298cd43426cdbb586b.js